import * as n from "react";
import { Component as tr, useState as S, useRef as q, useEffect as G, useLayoutEffect as je, isValidElement as sn, cloneElement as na, forwardRef as Wr, useContext as xn, createContext as Dn, useMemo as we, useCallback as le, Fragment as Hr, Children as Kn, createRef as Kr } from "react";
import { createPortal as Ur } from "react-dom";
const Yr = "_page_1f94v_5", Gr = "_inner_1f94v_18", fa = {
  page: Yr,
  inner: Gr
};
function DE({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  className: a = "",
  style: r,
  children: o
}) {
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [fa.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...r }
    },
    /* @__PURE__ */ n.createElement("div", { className: fa.inner, style: { minWidth: t } }, o)
  );
}
const Vr = "_orbitPortalRoot_177qv_2", Jr = {
  orbitPortalRoot: Vr
};
class Ut extends tr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Jr.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return Ur(this.props.children, this.getPortalRoot());
  }
}
const Qr = "_anchor_7h2m7_2", Zr = "_tip_7h2m7_5", _a = {
  anchor: Qr,
  tip: Zr
};
let eo = 0;
function Bt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = S(!1), [u, d] = S({ top: 0, left: 0 }), p = q(null), _ = q(null), y = q(null), f = q("");
  f.current || (f.current = `axe-tip-${++eo}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, $ = (E) => {
    b(), E <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), E);
  }, k = () => {
    b(), m(!1);
  };
  G(() => b, []), je(() => {
    if (!i) return;
    const E = () => {
      const g = p.current, h = _.current;
      if (!g || !h) return;
      const N = g.getBoundingClientRect(), D = h.offsetHeight, j = h.offsetWidth;
      let B = a === "top" ? N.top - D - 6 : N.bottom + 6;
      a === "bottom" && B + D > window.innerHeight - 4 && N.top - D - 6 > 4 && (B = N.top - D - 6), a === "top" && B < 4 && N.bottom + 6 + D < window.innerHeight - 4 && (B = N.bottom + 6);
      const R = Math.max(4, Math.min(N.left + N.width / 2 - j / 2, window.innerWidth - j - 4));
      d((T) => T.top === B && T.left === R ? T : { top: B, left: R });
    };
    return E(), window.addEventListener("resize", E), window.addEventListener("scroll", E, !0), () => {
      window.removeEventListener("resize", E), window.removeEventListener("scroll", E, !0);
    };
  }, [i, a, e]), G(() => {
    if (!i) return;
    const E = (g) => {
      g.key !== "Escape" || g.isComposing || (g.preventDefault(), g.stopPropagation(), k());
    };
    return document.addEventListener("keydown", E, !0), () => document.removeEventListener("keydown", E, !0);
  }, [i]);
  const w = e != null && e !== !1 && e !== "";
  if (!w && !c) return t;
  const x = w && sn(t) ? na(t, i && s ? { "aria-describedby": f.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: p,
      className: [_a.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        w && $(r);
      },
      onMouseLeave: k,
      onFocus: () => {
        w && $(0);
      },
      onBlur: k
    },
    x,
    w && i && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: _,
        id: f.current,
        role: "tooltip",
        className: _a.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: k
      },
      e
    ))
  );
}
const to = "_bar_bhn0l_1", no = "_menu_bhn0l_9", ao = "_title_bhn0l_19", ro = "_info_bhn0l_21", oo = "_badge_bhn0l_29", so = "_badge_muted_bhn0l_30", lo = "_badge_ok_bhn0l_31", co = "_badge_warn_bhn0l_32", io = "_meta_bhn0l_34", uo = "_actions_bhn0l_18", mo = "_notice_bhn0l_51", fo = "_notice_info_bhn0l_57", _o = "_notice_ok_bhn0l_58", po = "_notice_err_bhn0l_59", Ge = {
  bar: to,
  menu: no,
  title: ao,
  info: ro,
  badge: oo,
  badge_muted: so,
  badge_ok: lo,
  badge_warn: co,
  meta: io,
  actions: uo,
  notice: mo,
  notice_info: fo,
  notice_ok: _o,
  notice_err: po
};
function AE({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(Bt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const yo = "_btn_a0orf_1", bo = "_sm_a0orf_18", ho = "_primary_a0orf_21", go = "_dark_a0orf_23", Eo = "_danger_a0orf_25", vo = "_soon_a0orf_29", ko = "_soonTag_a0orf_30", wo = "_blocked_a0orf_39", No = "_kbd_a0orf_51", $o = "_iconBtn_a0orf_54", xo = "_link_a0orf_70", ut = {
  btn: yo,
  sm: bo,
  primary: ho,
  dark: go,
  danger: Eo,
  soon: vo,
  soonTag: ko,
  blocked: wo,
  kbd: No,
  iconBtn: $o,
  link: xo
}, Ft = Wr(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    kbd: s,
    soon: l,
    blockedReason: c,
    children: i,
    className: m = "",
    type: u = "button",
    onClick: d,
    title: p,
    disabled: _,
    ...y
  } = t, f = l || c || "", b = f !== "", $ = "blockedReason" in t, k = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: u,
      className: [ut.btn, ut[r], o === "sm" ? ut.sm : "", l ? ut.soon : b ? ut.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": b ? !0 : void 0,
      disabled: b ? void 0 : _,
      title: b ? void 0 : p,
      onClick: b ? (w) => w.preventDefault() : d,
      ...y
    },
    i,
    s && /* @__PURE__ */ n.createElement("kbd", { className: ut.kbd }, s),
    l && /* @__PURE__ */ n.createElement("em", { className: ut.soonTag }, "준비 중")
  );
  return b || $ ? /* @__PURE__ */ n.createElement(Bt, { content: f, keepWrapper: $ }, k) : k;
});
function Un({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(Bt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [ut.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function aa({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [ut.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Do = "_wrap_10shm_1", Ao = "_btn_10shm_2", Co = "_on_10shm_6", So = "_caret_10shm_8", Mo = "_pop_10shm_9", To = "_sec_10shm_14", Bo = "_item_10shm_17", jo = "_danger_10shm_24", _t = {
  wrap: Do,
  btn: Ao,
  on: Co,
  caret: So,
  pop: Mo,
  sec: To,
  item: Bo,
  danger: jo
}, Lo = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), CE = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function qo({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = S(!1), l = q(null), c = q(null), i = q(null), m = () => {
    var d, p;
    return Array.from((p = (d = i.current) == null ? void 0 : d.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  G(() => {
    var d;
    o && ((d = m()[0]) == null || d.focus());
  }, [o]), G(() => {
    if (!o) return;
    const d = (_) => {
      l.current && !l.current.contains(_.target) && s(!1);
    }, p = (_) => {
      var y;
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", p, !0), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", p, !0);
    };
  }, [o]);
  const u = (d) => {
    const p = m();
    if (p.length === 0) return;
    const _ = p.indexOf(document.activeElement);
    let y = -1;
    if (d.key === "ArrowDown") y = (_ + 1) % p.length;
    else if (d.key === "ArrowUp") y = (_ <= 0 ? p.length : _) - 1;
    else if (d.key === "Home") y = 0;
    else if (d.key === "End") y = p.length - 1;
    else if (d.key === "Tab") {
      s(!1);
      return;
    } else return;
    d.preventDefault(), p[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: _t.wrap, ref: l }, /* @__PURE__ */ n.createElement(Bt, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [_t.btn, o ? _t.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((d) => !d),
      onKeyDown: (d) => {
        d.key === "ArrowDown" && !o && (d.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: _t.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: _t.pop, role: "menu", onKeyDown: u }, t.map((d) => d.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: d.key, className: _t.sec }, d.label, d.note && /* @__PURE__ */ n.createElement("small", null, d.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "menuitem",
      disabled: d.disabled,
      className: [_t.item, d.danger ? _t.danger : ""].join(" "),
      onClick: () => {
        var p;
        s(!1), (p = c.current) == null || p.focus(), d.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, d.label),
    d.disabled && d.reason && /* @__PURE__ */ n.createElement("small", null, d.reason)
  ))));
}
function SE(e, t, a = !0) {
  const r = q(t);
  r.current = t, G(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function Ro() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Io = "_bar_1g564_2", Oo = "_sticky_1g564_12", Po = "_start_1g564_19", Xo = "_end_1g564_20", zo = "_status_1g564_22", Fo = "_dirty_1g564_23", Wo = "_kbd_1g564_25", vt = {
  bar: Io,
  sticky: Oo,
  start: Po,
  end: Xo,
  status: zo,
  dirty: Fo,
  kbd: Wo
};
function ME({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", vt.bar, o ? "" : vt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: vt.start }, e), /* @__PURE__ */ n.createElement("span", { className: vt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [vt.status, r ? vt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: vt.kbd }, Ro())));
}
const Ho = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Ko = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Uo({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Ko[e]);
}
function hn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Ho[e]
  );
}
const Yo = "_root_j67qt_2", Go = "_closed_j67qt_3", Vo = "_tab_j67qt_6", Jo = "_collapse_j67qt_7", Qo = "_body_j67qt_16", Zo = "_card_j67qt_32", es = "_head_j67qt_37", ts = "_cardOpen_j67qt_44", ns = "_headBtn_j67qt_47", as = "_icon_j67qt_56", rs = "_badge_j67qt_57", os = "_trailing_j67qt_58", ss = "_chev_j67qt_59", ls = "_panelWrap_j67qt_63", cs = "_panelOpen_j67qt_67", is = "_panelBody_j67qt_68", us = "_panelInner_j67qt_69", ms = "_panelSettled_j67qt_70", ve = {
  root: Yo,
  closed: Go,
  tab: Vo,
  collapse: Jo,
  body: Qo,
  card: Zo,
  head: es,
  cardOpen: ts,
  headBtn: ns,
  icon: as,
  badge: rs,
  trailing: os,
  chev: ss,
  panelWrap: ls,
  panelOpen: cs,
  panelBody: is,
  panelInner: us,
  panelSettled: ms
}, ds = 1280, fs = 8, nr = "axe-side-bar:";
function _s(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(nr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function ps(e, t) {
  if (e)
    try {
      window.localStorage.setItem(nr + e, t ? "1" : "0");
    } catch {
    }
}
function TE({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = ds,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var p;
  const c = q(_s(o)), [i, m] = S((p = c.current) != null ? p : t), u = q(c.current !== null);
  if (G(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const _ = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!_.matches && t);
    };
    return y(), _.addEventListener ? _.addEventListener("change", y) : _.addListener(y), () => {
      _.removeEventListener ? _.removeEventListener("change", y) : _.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const d = () => {
    u.current = !0, ps(o, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : fs }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(Bt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: d,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Uo, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const ar = Dn(null);
function BE({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = S(t);
  return a ? /* @__PURE__ */ n.createElement(ar.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const rr = "axe-side-panel:";
function ys(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(rr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function bs(e, t) {
  if (e)
    try {
      window.localStorage.setItem(rr + e, t ? "1" : "0");
    } catch {
    }
}
function jE({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var E;
  const u = xn(ar), d = !!u && c != null, p = q(ys(l)), [_, y] = S((E = p.current) != null ? E : a), f = d ? u.openId === c : _, [b, $] = S(f), [k, w] = S(f);
  if (!t) return null;
  f && !b && $(!0);
  const x = () => {
    const g = !f;
    bs(l, g), $(!0), w(!1), d ? u.setOpenId(g ? c : null) : y(g);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, f ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": f }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (g) => g.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, f ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (g) => {
        g.target === g.currentTarget && g.propertyName === "grid-template-rows" && w(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, f && k ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, m))
  ));
}
const hs = "_guide_qnh7l_1", gs = "_title_qnh7l_5", Es = "_desc_qnh7l_6", vs = "_act_qnh7l_7", ks = "_why_qnh7l_13", ws = "_steps_qnh7l_14", Ns = "_no_qnh7l_20", $s = "_cur_qnh7l_24", xs = "_link_qnh7l_26", rt = {
  guide: hs,
  title: gs,
  desc: Es,
  act: vs,
  why: ks,
  steps: ws,
  no: Ns,
  cur: $s,
  link: xs
};
function LE({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: rt.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: rt.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: rt.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: rt.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: rt.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? rt.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: rt.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const Ds = "_list_1w2rs_1", As = "_row_1w2rs_2", Cs = "_label_1w2rs_6", Ss = "_value_1w2rs_7", Ms = "_emphasis_1w2rs_8", Ts = "_changed_1w2rs_10", qt = {
  list: Ds,
  row: As,
  label: Cs,
  value: Ss,
  emphasis: Ms,
  changed: Ts
};
function qE({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [qt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [qt.row, a.emphasis ? qt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: qt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [qt.value, a.changed ? qt.changed : ""].join(" ") }, a.value))));
}
const Bs = "_underline_xl221_2", js = "_active_xl221_24", Ls = "_segmented_xl221_33", Ln = {
  underline: Bs,
  active: js,
  segmented: Ls
};
function or({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Ln.segmented : Ln.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Ln.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const qs = "_bar_1e999_1", Rs = "_actions_1e999_17", Is = "_field_1e999_24", Os = "_fieldLabel_1e999_25", Ps = "_readout_1e999_33", Xs = "_search_1e999_44", zs = "_detail_1e999_58", Fs = "_pill_1e999_70", Ws = "_hint_1e999_81", mt = {
  bar: qs,
  actions: Rs,
  field: Is,
  fieldLabel: Os,
  readout: Ps,
  search: Xs,
  detail: zs,
  pill: Fs,
  hint: Ws
}, Hs = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Ks(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Hs.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function RE({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  trailing: i,
  enterSearch: m = !0
}) {
  const u = (d) => {
    !m || !t || r || !Ks(d) || (d.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: mt.bar, onKeyDown: u }, e, /* @__PURE__ */ n.createElement("span", { className: mt.actions }, i, s && /* @__PURE__ */ n.createElement("button", { type: "button", className: mt.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(Bt, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: mt.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Us({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: mt.field }, /* @__PURE__ */ n.createElement("span", { className: mt.fieldLabel }, e), t);
}
function IE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.readout }, e);
}
function OE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.pill, role: "status" }, e);
}
function PE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.hint }, e);
}
function Ys(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function XE({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(Us, { label: o }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ n.createElement("option", { key: s.gisu, value: s.gisu }, Ys(s)))
  ));
}
class sr {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function lr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function cr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function ir(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Gs(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function ur(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Vs(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => ur(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function Js(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function Qs(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = o.length;
    for (; m < u; ) {
      const d = m + u >> 1;
      r[o[d]] < c ? m = d + 1 : u = d;
    }
    m > 0 && (s[i] = o[m - 1]), o[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const Zs = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', el = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function tl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function nl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = tl(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(Zs)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function pa(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Gs(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function al(e) {
  if (e.matches(el) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function rl() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function ol(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const mr = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function sl(e, t, a) {
  if (mr(t, a)) return;
  const r = Qs(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function ll(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? pa(c.rows[0], a) : null }));
    return l.sort((c, i) => ur(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = al(l);
    return { level: c, value: c === null ? null : pa(l, a) };
  });
  return Vs(s, r).map((l) => o[l]);
}
function cl(e, t, a) {
  const r = ol(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && mr(o, a.shown)) return;
  a.base = a.sig ? Js(a.base, o) : o;
  let l = t ? ll(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  sl(r.parent, l, o), a.shown = l, a.sig = s;
}
const il = "input, select, textarea, button";
function ul(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const o = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), s = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    o !== "" && !r.querySelector(il) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: o, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || s) && (r.getAttribute("title") !== o && r.setAttribute("title", o), r.dataset.axeTitle !== o && (r.dataset.axeTitle = o))) : s && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const dr = Dn(null), ml = "_card_1j6er_2", dl = "_grow_1j6er_24", fl = "_head_1j6er_26", _l = "_title_1j6er_35", pl = "_trailing_1j6er_36", yl = "_scroll_1j6er_6", bl = "_foot_1j6er_54", hl = "_strip_1j6er_56", gl = "_pager_1j6er_58", El = "_spacer_1j6er_60", vl = "_table_1j6er_62", kl = "_fixed_1j6er_63", wl = "_fz_1j6er_81", Nl = "_fzEdge_1j6er_93", $l = "_frozen_1j6er_100", xl = "_sr_1j6er_162", Dl = "_statusCell_1j6er_43", Al = "_status_1j6er_43", Cl = "_st_error_1j6er_244", Sl = "_stIcon_1j6er_245", Ml = "_spin_1j6er_251", Tl = "_axeSpin_1j6er_1", Bl = "_busy_1j6er_261", jl = "_statusRow_1j6er_263", Ll = "_busyBar_1j6er_264", ql = "_axeBusy_1j6er_1", ie = {
  card: ml,
  grow: dl,
  head: fl,
  title: _l,
  trailing: pl,
  scroll: yl,
  foot: bl,
  strip: hl,
  pager: gl,
  spacer: El,
  table: vl,
  fixed: kl,
  fz: wl,
  fzEdge: Nl,
  frozen: $l,
  sr: xl,
  statusCell: Dl,
  status: Al,
  st_error: Cl,
  stIcon: Sl,
  spin: Ml,
  axeSpin: Tl,
  busy: Bl,
  statusRow: jl,
  busyBar: Ll,
  axeBusy: ql
}, Rl = 120;
function Il(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Rl : void 0;
}
function ya({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Wt = /* @__PURE__ */ new Set();
function ra() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function Ol(e) {
  if (!ra() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var o;
    return (o = r.textContent) == null ? void 0 : o.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Wt.has(a) || (Wt.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Pl(e) {
  if (!ra()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var o, s;
    r.scrollWidth > r.clientWidth + 1 && t.push((s = (o = r.textContent) == null ? void 0 : o.trim()) != null ? s : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Wt.has(a) || (Wt.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Xl(e) {
  if (!ra() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Wt.has(t)) return;
  Wt.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function ba(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ie.fz, i), l.classList.toggle(ie.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + c; m += 1) r.set(m, l.rowSpan);
      s += c;
    }
  }
}
function zE({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: d = !0,
  sort: p,
  onSort: _,
  manualSort: y,
  className: f = "",
  children: b
}) {
  const $ = l || e !== void 0 && e.length > 0, k = $ ? Il(e) : void 0, { stick: w, offsets: x } = we(() => {
    const X = Math.max(Math.trunc(c), 0), z = [];
    if (X === 0 || !e) return { stick: 0, offsets: z };
    let O = 0, K = 0;
    for (let Q = 0; Q < X; Q += 1) {
      const Ne = e[Q];
      if (typeof Ne != "number") break;
      z.push(O), O += Ne, K += 1;
    }
    return { stick: K, offsets: z };
  }, [e, c]), E = [ie.table, $ ? ie.fixed : "", w > 0 ? ie.frozen : ""].filter(Boolean).join(" "), g = q(null), h = q(null), N = q(null), D = q(null), j = q(0), B = q(0), R = we(() => ({
    scrollRef: g,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (B.current += 1, () => {
      B.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [T, P] = S(null), ee = p !== void 0 ? p : T, [F, L] = S(""), ae = q(rl()), te = () => {
    const X = g.current, z = N.current, O = D.current;
    if (!X || !z || !O) return;
    const K = X.scrollWidth;
    O.style.width = K + "px", z.style.display = K > X.clientWidth + 1 ? "" : "none";
    const Q = X.offsetWidth - X.clientWidth;
    z.style.paddingRight = Q + "px", h.current && (h.current.style.paddingRight = Q + "px"), Pl(X), Xl(ul(X.querySelector("table")));
  };
  G(() => {
    const X = g.current;
    if (!X) return;
    const z = new sr(X, te);
    return Ol(X.querySelector("table")), () => z.detach();
  }, []), je(() => {
    var X, z, O, K, Q;
    (w > 0 || j.current > 0) && (ba((z = (X = g.current) == null ? void 0 : X.querySelector("table")) != null ? z : null, w, x), ba((K = (O = h.current) == null ? void 0 : O.querySelector("table")) != null ? K : null, w, x)), j.current = w, (Q = g.current) == null || Q.querySelectorAll("thead th:not([scope])").forEach((Ne) => Ne.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var K;
    const X = (K = g.current) == null ? void 0 : K.querySelector("table");
    if (!X) return;
    const z = d ? nl(X) : [];
    X.querySelectorAll("thead th[data-axe-sort]").forEach((Q) => {
      z.some((Ne) => Ne.th === Q) || (Q.removeAttribute("data-axe-sort"), Q.removeAttribute("aria-sort"), Q.removeAttribute("tabindex"));
    }), z.forEach(({ th: Q, key: Ne }) => {
      Q.dataset.axeSort !== Ne && (Q.dataset.axeSort = Ne);
      const He = cr(ee, Ne);
      Q.getAttribute("aria-sort") !== He && Q.setAttribute("aria-sort", He), Q.hasAttribute("tabindex") || Q.setAttribute("tabindex", "0");
    });
    const O = ee && z.find((Q) => Q.key === ee.key);
    cl(X, ee && O && !y && B.current === 0 ? { col: O.col, dir: ee.dir } : null, ae.current);
  }
  const I = (X) => {
    var Q;
    const z = X.dataset.axeSort;
    if (z === void 0) return;
    const O = lr(ee, z), K = ((Q = X.textContent) != null ? Q : "").replace(/\s+/g, " ").trim();
    L(ir(O, () => K)), p === void 0 && P(O), _ == null || _(O);
  }, Y = (X) => {
    var K, Q;
    const z = X, O = (K = z.closest) == null ? void 0 : K.call(z, "thead th[data-axe-sort]");
    return !O || !((Q = g.current) != null && Q.contains(O)) || z !== O && z.closest('input, select, textarea, button, a[href], [role="button"]') ? null : O;
  }, Z = (X) => {
    const z = Y(X.target);
    z && I(z);
  }, A = (X) => {
    if (X.key !== "Enter" && X.key !== " ") return;
    const z = Y(X.target);
    !z || X.target !== z || (X.preventDefault(), I(z));
  }, V = (X) => {
    const z = X.target.scrollLeft;
    g.current && (g.current.scrollLeft = z), h.current && (h.current.scrollLeft = z);
  }, J = (X) => {
    const z = X.target.scrollLeft;
    h.current && (h.current.scrollLeft = z), N.current && (N.current.scrollLeft = z);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ie.card, s ? ie.grow : "", i ? ie.busy : "", f].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ie.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ie.head }, /* @__PURE__ */ n.createElement("span", { className: ie.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ie.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ie.scroll, ref: g, onScroll: J }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: E,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: k ? { minWidth: k } : void 0,
      onClick: d ? Z : void 0,
      onKeyDown: d ? A : void 0
    },
    /* @__PURE__ */ n.createElement(ya, { cols: e }),
    /* @__PURE__ */ n.createElement(dr.Provider, { value: R }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ie.foot, ref: h }, /* @__PURE__ */ n.createElement("table", { className: E, style: k ? { minWidth: k } : void 0 }, /* @__PURE__ */ n.createElement(ya, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ie.strip, ref: N, onScroll: V }, /* @__PURE__ */ n.createElement("div", { ref: D, className: ie.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ie.pager }, a), d && /* @__PURE__ */ n.createElement("span", { className: ie.sr, role: "status", "aria-live": "polite" }, F));
}
const zl = 600;
function ha(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : zl, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Fl(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Wl(e, t) {
  return e.start === t.start && e.end === t.end;
}
const ga = /* @__PURE__ */ new Set();
function Ea({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function FE({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var E;
  const i = xn(dr), m = q(null), [u, d] = S(() => ha({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), p = e.length, [_, y] = S(null), f = _ && _.of === t ? _.px : t;
  je(() => i ? i.registerVirtual() : void 0, [i]), je(() => {
    var h;
    const g = (h = m.current) == null ? void 0 : h.closest("table");
    if (g)
      return g.setAttribute("aria-rowcount", String(p + l)), () => g.removeAttribute("aria-rowcount");
  }, [p, l]), G(() => {
    const g = i == null ? void 0 : i.scrollRef.current, h = m.current;
    if (!g || !h) return;
    const N = () => {
      const j = h.getBoundingClientRect().top - g.getBoundingClientRect().top + g.scrollTop, B = ha({ count: p, rowHeight: f, scrollTop: g.scrollTop, viewport: g.clientHeight, bodyTop: j, overscan: o });
      d((R) => Wl(R, B) ? R : B);
    };
    N(), g.addEventListener("scroll", N, { passive: !0 });
    const D = typeof ResizeObserver == "function" ? new ResizeObserver(N) : null;
    return D ? D.observe(g) : window.addEventListener("resize", N), () => {
      g.removeEventListener("scroll", N), D ? D.disconnect() : window.removeEventListener("resize", N);
    };
  }, [i, p, f, o]), je(() => {
    var N, D, j;
    const g = (N = m.current) == null ? void 0 : N.querySelector("tr:not([data-virtual-spacer])"), h = (D = g == null ? void 0 : g.getBoundingClientRect().height) != null ? D : 0;
    !(h > 0) || Math.abs(h - f) <= 0.25 || (y({ of: t, px: h }), typeof process != "undefined" && ((j = process.env) == null ? void 0 : j.NODE_ENV) !== "production" && Math.abs(h - t) > 2 && !ga.has(t) && (ga.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(h)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [f, t, p]);
  const b = Math.min(u.end, p), $ = Math.min(u.start, b), k = Fl(p, f, { start: $, end: b }), w = (E = s != null ? s : i == null ? void 0 : i.colCount) != null ? E : 1, x = [];
  for (let g = $; g < b; g += 1) {
    const h = a(e[g], g), N = r ? r(e[g], g) : g;
    x.push(sn(h) ? na(h, { key: N, "aria-rowindex": g + 1 + l }) : h);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(Ea, { height: k.top, colSpan: w }), x, /* @__PURE__ */ n.createElement(Ea, { height: k.bottom, colSpan: w }));
}
const Hl = 7.09, Kl = 3.88, Ul = 4.46, Yl = 16, Gl = 2;
function Vl(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * Hl + r * Kl + (t.negative ? Ul : 0) + Yl + Gl;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function WE(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Vl(a, { ...t, negative: r });
}
function HE(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const kt = 12, Jl = 1.06, Ql = 16, Zl = 4;
function ec(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? kt : e === " " ? kt * 0.3 : /[0-9]/.test(e) ? kt * 0.56 : /[A-Z]/.test(e) ? kt * 0.68 : /[a-z]/.test(e) ? kt * 0.56 : /[.,:;'|!]/.test(e) ? kt * 0.3 : kt * 0.6;
}
function tc(e, t = !1) {
  let a = 0;
  for (const r of e) a += ec(r);
  return t ? a * Jl : a;
}
function KE(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = tc(i, t.bold);
    m > a && (a = m);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + Ql + ((l = t.extra) != null ? l : 0) + Zl);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function UE({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = "조회 결과가 없습니다",
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let d;
  if (i) d = "error";
  else if (t && m) d = "loading";
  else if (r == null) {
    if (s === null) return null;
    d = "idle";
  } else if (r === 0) d = "empty";
  else return null;
  const p = /* @__PURE__ */ n.createElement(n.Fragment, null, d === "loading" && /* @__PURE__ */ n.createElement("span", { className: ie.spin, "aria-hidden": "true" }), d === "error" && /* @__PURE__ */ n.createElement("span", { className: ie.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, d === "error" ? u : d === "loading" ? l : d === "idle" ? s : o)), _ = /* @__PURE__ */ n.createElement("div", { className: [ie.status, ie[`st_${d}`]].join(" "), role: "status" }, p);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": d }, _) : /* @__PURE__ */ n.createElement("tr", { className: [ie.statusRow, c].filter(Boolean).join(" "), "data-state": d }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ie.statusCell }, _));
}
function YE(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const nc = "_cell_n9rrj_1", ac = "_toggle_n9rrj_2", rc = "_spacer_n9rrj_8", oc = "_label_n9rrj_9", sc = "_dim_n9rrj_10", Vt = {
  cell: nc,
  toggle: ac,
  spacer: rc,
  label: oc,
  dim: sc
};
function GE(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = S(() => /* @__PURE__ */ new Set()), [l, c] = S(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = we(() => {
    const _ = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), f = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const $ = a(b), k = $ == null || !f.has(String($)) ? null : String($);
      _.set(String(t(b)), k), k && y.add(k);
    }
    return { parents: _, kids: y };
  }, [e, t, a]), u = le((_) => r ? !o.has(_) : l.has(_), [r, o, l]), d = we(() => e.filter((_) => {
    var b, $;
    let y = (b = i.get(String(t(_)))) != null ? b : null;
    const f = /* @__PURE__ */ new Set();
    for (; y && !f.has(y); ) {
      if (!u(y)) return !1;
      f.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
    return !0;
  }), [e, i, t, u]), p = le((_, y) => {
    const f = (b, $) => {
      const k = new Set(b);
      return $ ? k.add(_) : k.delete(_), k;
    };
    r ? s((b) => f(b, !y)) : c((b) => f(b, y));
  }, [r]);
  return {
    visible: d,
    hasChildren: (_) => m.has(String(t(_))),
    isOpen: (_) => u(String(t(_))),
    toggle: (_) => {
      const y = String(t(_));
      p(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const _ = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        s(_), c(y);
      };
    },
    reveal: (_) => {
      var b, $;
      let y = (b = i.get(String(_))) != null ? b : null;
      const f = /* @__PURE__ */ new Set();
      for (; y && !f.has(y); )
        p(y, !0), f.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
  };
}
function VE({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const m = (d) => {
    d.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Vt.cell, o ? Vt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Vt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Vt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Vt.label, title: u }, i)
  );
}
function lc(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: cc(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function cc(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function JE(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = q(null), [s, l] = S(null);
  G(() => {
    e.current !== s && l(e.current);
  }), G(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((f) => f.matches(r)) || y[0]), y.forEach((f) => {
        const b = f === o.current ? "0" : "-1";
        f.getAttribute("tabindex") !== b && f.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), f = [], b = [], $ = /* @__PURE__ */ new Map(), k = [];
      return y.forEach((w) => {
        var j;
        const x = w.tagName === "TR", E = x ? null : w.closest("td, th"), g = E && s.contains(E) ? E.parentElement : null, h = x ? w : (j = g != null ? g : w.parentElement) != null ? j : s;
        let N = f.indexOf(h);
        N < 0 && (N = f.length, f.push(h), b.push([]), k.push([]));
        let D;
        if (x)
          D = 0;
        else if (E && g) {
          D = 0;
          for (const B of Array.from(g.cells)) {
            if (B === E) break;
            D += Math.max(1, B.colSpan || 1);
          }
        } else
          D = b[N].length;
        $.set(w, { r: N, i: b[N].length }), b[N].push(D), k[N].push(w);
      }), { rows: b, where: $, byPos: k };
    }, d = (y) => {
      var g;
      const f = y.target;
      if (!f || !f.matches(a) || !s.contains(f) || y.altKey || y.metaKey || f.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: $, byPos: k } = u(), w = $.get(f);
      if (!w) return;
      const x = lc(b, w, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const E = (g = k[x.r]) == null ? void 0 : g[x.i];
      E && (o.current = E, m(), E.focus());
    }, p = (y) => {
      const f = y.target;
      !f || !f.matches(a) || f === o.current || (o.current = f, m());
    };
    m(), s.addEventListener("keydown", d), s.addEventListener("focusin", p);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return _ == null || _.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", d), s.removeEventListener("focusin", p), _ == null || _.disconnect();
    };
  }, [s, a, r]);
}
const ic = "_btn_r1trx_1", uc = "_mark_r1trx_7", mc = "_sr_r1trx_9", Yn = {
  btn: ic,
  mark: uc,
  sr: mc
};
function QE({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = cr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Yn.btn, onClick: () => a(lr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Yn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function ZE({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Yn.sr, role: "status", "aria-live": "polite" }, ir(e, t));
}
const dc = "_card_14vt3_1", fc = "_accent_14vt3_8", _c = "_grow_14vt3_9", pc = "_head_14vt3_11", yc = "_body_14vt3_20", bc = "_title_14vt3_28", hc = "_trailing_14vt3_29", gc = "_summary_14vt3_32", Ec = "_sumHead_14vt3_33", vc = "_sumTotal_14vt3_42", kc = "_tone_warn_14vt3_43", wc = "_tone_ok_14vt3_44", Nc = "_sumList_14vt3_46", $c = "_sumEm_14vt3_55", xc = "_sumFoot_14vt3_57", Dc = "_sumNote_14vt3_66", xe = {
  card: dc,
  accent: fc,
  grow: _c,
  head: pc,
  body: yc,
  title: bc,
  trailing: hc,
  summary: gc,
  sumHead: Ec,
  sumTotal: vc,
  tone_warn: kc,
  tone_ok: wc,
  sumList: Nc,
  sumEm: $c,
  sumFoot: xc,
  sumNote: Dc
};
function fr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [xe.card, a ? xe.accent : "", r ? xe.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: xe.head }, /* @__PURE__ */ n.createElement("span", { className: xe.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: xe.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", xe.body].join(" ") }, l)
  );
}
function e0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [xe.card, xe.accent, xe.summary, xe[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: xe.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: xe.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: xe.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? xe.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: xe.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: xe.sumNote }, s));
}
let Ac = 0;
function Yt(e = "axe") {
  const t = q(null);
  return t.current || (t.current = `${e}-${++Ac}`), t.current;
}
const Cc = "_sr_1y2mv_2", Sc = "_skip_1y2mv_8", Mc = "_crit_1y2mv_16", Tc = "_c_danger_1y2mv_21", Bc = "_c_warn_1y2mv_22", jc = "_critI_1y2mv_23", Lc = "_critBody_1y2mv_24", qc = "_critX_1y2mv_25", Rc = "_ch_1y2mv_32", Ic = "_chBtn_1y2mv_33", Oc = "_chBox_1y2mv_43", Ze = {
  sr: Cc,
  skip: Sc,
  crit: Mc,
  c_danger: Tc,
  c_warn: Bc,
  critI: jc,
  critBody: Lc,
  critX: qc,
  ch: Rc,
  chBtn: Ic,
  chBox: Oc
};
function _r({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Ze.sr, id: a }, t);
}
function t0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Ze.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function n0({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Ze.crit, Ze[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Ze.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Ze.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ze.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function a0({ label: e, children: t, className: a = "" }) {
  const [r, o] = S(!1), s = Yt("axe-ch"), l = q(null), c = q(null);
  return G(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && o(!1);
    }, m = (u) => {
      var d;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), o(!1), (d = c.current) == null || d.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Ze.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Ze.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: Ze.chBox }, t));
}
function Gn(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function Pc(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Gn(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Xc(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const zc = "_root_umk7w_1", Fc = "_rootNone_umk7w_5", Wc = "_field_umk7w_12", Hc = "_codeInput_umk7w_13", Kc = "_pickBtn_umk7w_17", Uc = "_suggest_umk7w_34", Yc = "_suggestList_umk7w_40", Gc = "_suggestRow_umk7w_41", Vc = "_suggestOn_umk7w_42", Jc = "_suggestEmpty_umk7w_47", Qc = "_suggestMore_umk7w_47", Zc = "_popup_umk7w_51", ei = "_popupHead_umk7w_65", ti = "_searchRow_umk7w_75", ni = "_list_umk7w_79", ai = "_current_umk7w_88", ri = "_empty_umk7w_92", oi = "_summaryBtn_umk7w_100", si = "_ov_umk7w_121", li = "_modal_umk7w_132", ci = "_modalWide_umk7w_132", ii = "_head_umk7w_144", ui = "_sub_umk7w_152", mi = "_x_umk7w_154", di = "_body_umk7w_171", fi = "_chips_umk7w_179", _i = "_chip_umk7w_179", pi = "_chipOn_umk7w_193", yi = "_search_umk7w_75", bi = "_tbl_umk7w_212", hi = "_row_umk7w_242", gi = "_rowCursor_umk7w_244", Ei = "_rowPicked_umk7w_245", vi = "_rowCurrent_umk7w_246", ki = "_curTag_umk7w_247", wi = "_busy_umk7w_248", Ni = "_count_umk7w_249", $i = "_chk_umk7w_251", xi = "_tdLeft_umk7w_252", Di = "_tdCenter_umk7w_253", Ai = "_emptyCell_umk7w_255", Ci = "_stop_umk7w_257", Si = "_more_umk7w_268", Mi = "_pager_umk7w_280", Ti = "_note_umk7w_293", Bi = "_foot_umk7w_296", ji = "_ghost_umk7w_305", Li = "_primary_umk7w_317", U = {
  root: zc,
  rootNone: Fc,
  field: Wc,
  codeInput: Hc,
  pickBtn: Kc,
  suggest: Uc,
  suggestList: Yc,
  suggestRow: Gc,
  suggestOn: Vc,
  suggestEmpty: Jc,
  suggestMore: Qc,
  popup: Zc,
  popupHead: ei,
  searchRow: ti,
  list: ni,
  current: ai,
  empty: ri,
  summaryBtn: oi,
  ov: si,
  modal: li,
  modalWide: ci,
  head: ii,
  sub: ui,
  x: mi,
  body: di,
  chips: fi,
  chip: _i,
  chipOn: pi,
  search: yi,
  tbl: bi,
  row: hi,
  rowCursor: gi,
  rowPicked: Ei,
  rowCurrent: vi,
  curTag: ki,
  busy: wi,
  count: Ni,
  chk: $i,
  tdLeft: xi,
  tdCenter: Di,
  emptyCell: Ai,
  stop: Ci,
  more: Si,
  pager: Mi,
  note: Ti,
  foot: Bi,
  ghost: ji,
  primary: Li
};
function qi({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, m] = S(""), u = we(() => {
    const d = i.trim().toLowerCase();
    return d ? e.filter(
      (p) => {
        var _;
        return p.code.toLowerCase().includes(d) || p.name.toLowerCase().includes(d) || ((_ = p.sub) != null ? _ : "").toLowerCase().includes(d);
      }
    ) : e;
  }, [e, i]);
  return G(() => {
    const d = (_) => {
      const y = _.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, p = (_) => {
      _.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", p);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (d) => m(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && u.length && l(u[0]), d.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, u.map((d) => /* @__PURE__ */ n.createElement("li", { key: d.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(d), className: d.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, d.code), /* @__PURE__ */ n.createElement("span", null, d.name), d.sub && /* @__PURE__ */ n.createElement("small", null, d.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const pr = 250, dn = 7;
function va(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Ri(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Ii({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  const m = we(() => Ri(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [d, p] = S(""), [_, y] = S(null), [f, b] = S(0), [$, k] = S([]), [w, x] = S(!1), [E, g] = S(!1), [h, N] = S(null), [D, j] = S(0), [B, R] = S(/* @__PURE__ */ new Map()), T = q(u);
  T.current = u, G(() => {
    p(""), y(null), b(0), j(0), N(null), R(new Map((o != null ? o : []).map((V) => [V.cd, V])));
    const A = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(A);
  }, [u.key]), G(() => {
    let A = !0;
    g(!0);
    const V = () => {
      T.current.fetch({ q: d.trim(), ty: _, page: f }).then((X) => {
        var O, K;
        if (!A) return;
        k((O = X.rows) != null ? O : []), x(!!X.hasMore), N(null);
        const z = s ? ((K = X.rows) != null ? K : []).findIndex((Q) => Q.cd === s) : -1;
        j(z > 0 ? z : 0);
      }).catch((X) => {
        A && (k([]), x(!1), N("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        A && g(!1);
      });
    }, J = window.setTimeout(V, d.trim() ? pr : 0);
    return () => {
      A = !1, window.clearTimeout(J);
    };
  }, [u.key, d, _, f]);
  const P = q(null);
  G(() => {
    const A = P.current && P.current.children[D];
    A && "scrollIntoView" in A && A.scrollIntoView({ block: "nearest" });
  }, [D, $]);
  const ee = we(() => {
    var V, J;
    const A = [
      { key: "cd", label: "코드", width: (V = u.codeWidth) != null ? V : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (X) => /* @__PURE__ */ n.createElement(n.Fragment, null, X.nm, X.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && A.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (X) => u.typeLabel ? u.typeLabel(X) : ""
    }), A.concat((J = u.extraColumns) != null ? J : []);
  }, [u]), F = le((A) => {
    R((V) => {
      const J = new Map(V);
      return J.has(A.cd) ? J.delete(A.cd) : J.set(A.cd, A), J;
    });
  }, []), L = le((A) => c([A]), [c]), ae = le(() => c(Array.from(B.values())), [B, c]), te = $.length > 0 && $.every((A) => B.has(A.cd)), v = () => {
    R((A) => {
      const V = new Map(A);
      return te ? $.forEach((J) => V.delete(J.cd)) : $.forEach((J) => V.set(J.cd, J)), V;
    });
  }, I = q(null);
  G(() => {
    const A = document.activeElement;
    return () => {
      window.setTimeout(() => {
        A && A.isConnected && typeof A.focus == "function" && (!document.activeElement || document.activeElement === document.body) && A.focus();
      }, 0);
    };
  }, []);
  const Y = q(i);
  Y.current = i, G(() => {
    const A = (V) => {
      V.key !== "Escape" || V.isComposing || (V.stopPropagation(), V.preventDefault(), Y.current());
    };
    return document.addEventListener("keydown", A, !0), () => document.removeEventListener("keydown", A, !0);
  }, []);
  const Z = (A) => {
    var X;
    if (A.nativeEvent.isComposing || A.keyCode === 229) return;
    if (A.key === "Tab" && I.current) {
      const z = Array.from(I.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (z.length) {
        const O = z[0], K = z[z.length - 1], Q = document.activeElement;
        A.shiftKey && Q === O ? (A.preventDefault(), K.focus()) : !A.shiftKey && Q === K && (A.preventDefault(), O.focus());
      }
      return;
    }
    if (A.key === "Escape") {
      A.stopPropagation(), i();
      return;
    }
    const V = A.target, J = V === l.current;
    if (!(!J && V !== I.current)) {
      if (A.key === "ArrowDown" || A.key === "ArrowUp") {
        A.preventDefault(), j((z) => Math.max(0, Math.min($.length - 1, z + (A.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (A.key === " " && r && $[D] && !(J && ((X = l.current) != null && X.value))) {
        A.preventDefault(), F($[D]);
        return;
      }
      if (A.key === "Enter") {
        if (A.preventDefault(), E) return;
        r ? ae() : $[D] && L($[D]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: I,
      onClick: (A) => A.stopPropagation(),
      onKeyDown: Z
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: _ === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((A) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: A.value,
        type: "button",
        className: _ === A.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(A.value), b(0);
        }
      },
      A.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (A) => {
          p(A.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), ee.map((A) => /* @__PURE__ */ n.createElement("th", { key: A.key, style: A.width ? { width: A.width } : void 0 }, A.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: P, className: E && $.length > 0 ? U.busy : void 0, "aria-busy": E }, $.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: ee.length + (r ? 1 : 0) }, E ? "검색 중…" : h || u.emptyText || "검색 결과가 없습니다")) : $.map((A, V) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: A.cd,
        className: [
          U.row,
          V === D ? U.rowCursor : "",
          B.has(A.cd) ? U.rowPicked : "",
          !r && s && A.cd === s ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": V === D,
        onClick: () => {
          j(V), r ? F(A) : L(A);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: B.has(A.cd),
          onChange: () => F(A),
          onClick: (J) => J.stopPropagation(),
          "aria-label": `${A.cd} 선택`
        }
      )),
      ee.map((J) => {
        var X, z;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: J.key,
            className: J.align === "left" ? U.tdLeft : U.tdCenter,
            title: J.render ? void 0 : String((X = A[J.key]) != null ? X : "")
          },
          J.render ? J.render(A) : String((z = A[J.key]) != null ? z : ""),
          J.key === "cd" && !r && s && A.cd === s && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, E ? "검색 중…" : h ? "" : `${$.length}건`, !r && !E && !h && $.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (w || f > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, w ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: f === 0, onClick: () => b((A) => Math.max(0, A - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, f + 1), w && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((A) => A + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, B.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => R(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: ae }, "확인"))
  )));
}
let Oi = 0;
function Pi({ source: e, items: t, anchorRef: a }) {
  const [r, o] = S(null), [s, l] = S(-1), [c, i] = S(null), m = q(null), u = q(0), d = q(`axe-cp-${++Oi}`), p = q(e);
  p.current = e;
  const _ = q(t);
  _.current = t;
  const y = le(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, o(null), l(-1);
  }, []);
  G(() => y, [y]);
  const f = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const $ = u.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let k = [], w = !1;
      try {
        const E = p.current;
        if (E) {
          const g = await E.fetch({ q: b, ty: null, page: 0 });
          k = g.rows, w = !!g.hasMore || k.length > dn;
        } else {
          const g = b.trim().toLowerCase();
          k = ((x = _.current) != null ? x : []).filter((h) => {
            var N;
            return h.code.toLowerCase().includes(g) || h.name.toLowerCase().includes(g) || ((N = h.sub) != null ? N : "").toLowerCase().includes(g);
          }).map((h) => ({ cd: h.code, nm: h.name, sub: h.sub })), w = k.length > dn;
        }
      } catch {
        return;
      }
      $ === u.current && (o({ rows: k.slice(0, dn), more: w, q: b }), l(-1));
    }, pr);
  };
  return G(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const $ = a.current;
      if (!$) return;
      const k = $.getBoundingClientRect(), w = Math.min(r.rows.length, dn) * 28 + 34, x = k.bottom + w > window.innerHeight - 8 && k.top - w - 2 > 8 ? k.top - w - 2 : k.bottom + 2, E = Math.max(k.width, 260);
      i({ left: Math.max(8, Math.min(k.left, window.innerWidth - E - 8)), top: x, width: E });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: d, runSuggest: f, cancelSuggest: y };
}
function r0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: d = "전체",
  open: p,
  onOpenChange: _,
  placeholder: y,
  title: f = "코드 선택",
  variant: b,
  disabled: $,
  className: k = "",
  maxLength: w,
  numeric: x = !1,
  ariaLabel: E,
  autoFocus: g,
  onEnter: h,
  onEscape: N,
  onBlur: D,
  invalid: j
}) {
  const B = s ? "source" : "static", R = E != null ? E : (s == null ? void 0 : s.title) || (typeof f == "string" && f !== "코드 선택" ? f : "") || "코드", T = b != null ? b : B === "source" ? "modal" : "anchor", P = u != null ? u : l ? "summary" : "input", [ee, F] = S(!1), L = p != null ? p : ee, ae = le(
    (H) => {
      p === void 0 && F(H), _ && _(H);
    },
    [p, _]
  ), te = q(null), v = q(null), I = q(null), [Y, Z] = S(null), A = () => {
    if (!$) {
      if (T === "anchor") {
        const H = te.current;
        if (!H) return;
        const fe = H.getBoundingClientRect(), ze = 320, Lt = fe.bottom + ze > window.innerHeight ? Math.max(8, fe.top - ze - 4) : fe.bottom + 4;
        Z({ left: Math.min(fe.left, window.innerWidth - 320), top: Lt });
      }
      ae(!0);
    }
  }, V = le(() => ae(!1), [ae]), [J, X] = S(!1), [z, O] = S(null), K = q(null);
  (!K.current || K.current.name !== t) && (K.current = { name: t, code: e });
  const Q = Xc(e, K.current, z, o), Ne = Gn(e, Q, a), He = Gn(e, Q), qe = (H) => {
    !l && H[0] && O({ code: H[0].cd, name: H[0].nm }), i ? i(H) : H[0] && r && r(H[0].cd, { code: H[0].cd, name: H[0].nm });
  }, { sugg: ue, active: Oe, setActive: jt, suggPos: at, suggId: Pe, runSuggest: Bn, cancelSuggest: Xe } = Pi({ source: s, items: o, anchorRef: te }), mn = (H) => {
    Xe(), qe([H]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: te, className: [P === "none" ? U.rootNone : U.root, k].filter(Boolean).join(" ") }, P === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: 24 },
      value: J ? e : Ne,
      placeholder: y,
      disabled: $,
      maxLength: w,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: g,
      "aria-label": R,
      "aria-invalid": j ? !0 : void 0,
      onChange: (H) => {
        const fe = H.target.value.trim(), ze = x ? fe.replace(/[^0-9]/g, "") : fe, Lt = w ? ze.slice(0, w) : ze;
        r && r(Lt), !$ && (s || o) && Bn(Lt);
      },
      onKeyDown: (H) => {
        if (H.key === "F2") {
          H.preventDefault(), Xe(), A();
          return;
        }
        if (!ue) {
          H.key === "Enter" && h && !H.nativeEvent.isComposing ? (H.preventDefault(), h()) : H.key === "Escape" && N && (H.preventDefault(), N());
          return;
        }
        const fe = ue.rows.length;
        H.key === "ArrowDown" && fe ? (H.preventDefault(), jt((ze) => (ze + 1) % fe)) : H.key === "ArrowUp" && fe ? (H.preventDefault(), jt((ze) => (ze <= 0 ? fe : ze) - 1)) : H.key === "Enter" && Oe >= 0 && ue.rows[Oe] ? (H.preventDefault(), mn(ue.rows[Oe])) : H.key === "Enter" && h && !H.nativeEvent.isComposing ? (H.preventDefault(), Xe(), h()) : H.key === "Escape" && (H.preventDefault(), H.stopPropagation(), H.nativeEvent.stopImmediatePropagation(), Xe());
      },
      onFocus: () => X(!0),
      onBlur: () => {
        X(!1), Xe(), D && D();
      },
      title: typeof j == "string" && j ? j : He && He !== e ? `${He} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!ue,
      "aria-controls": ue ? Pe.current : void 0,
      "aria-activedescendant": ue && Oe >= 0 ? `${Pe.current}-${Oe}` : void 0,
      "aria-describedby": typeof j == "string" && j ? `${Pe.current}-inv` : void 0
    }
  ), typeof j == "string" && j && /* @__PURE__ */ n.createElement(_r, { id: `${Pe.current}-inv` }, j), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: $,
      onClick: A,
      onMouseDown: (H) => H.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(hn, { name: "search", size: 13 })
  )), P === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: $, onClick: A }, /* @__PURE__ */ n.createElement("span", null, Pc(c != null ? c : [], d, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(hn, { name: "search", size: 13 }))), ue && at && P === "input" && !L && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: at.left, top: at.top, width: at.width },
      onMouseDown: (H) => H.preventDefault()
    },
    ue.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: Pe.current, role: "listbox", className: U.suggestList }, ue.rows.map((H, fe) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: H.cd,
        id: `${Pe.current}-${fe}`,
        role: "option",
        "aria-selected": fe === Oe,
        className: [U.suggestRow, fe === Oe ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => jt(fe),
        onClick: () => mn(H)
      },
      /* @__PURE__ */ n.createElement("code", null, va(H.cd, ue.q)),
      /* @__PURE__ */ n.createElement("span", null, va(H.nm, ue.q)),
      H.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    ue.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), L && B === "static" && T === "anchor" && Y && /* @__PURE__ */ n.createElement(
    qi,
    {
      items: o != null ? o : [],
      value: e,
      title: f,
      popupRef: v,
      anchorRef: te,
      pos: Y,
      onPick: (H) => {
        O({ code: H.code, name: H.name }), r && r(H.code, H), V();
      },
      onClose: V
    }
  ), L && (B === "source" || T === "modal") && /* @__PURE__ */ n.createElement(
    Ii,
    {
      source: s,
      items: o,
      title: f,
      multiple: l,
      selected: c,
      current: m,
      searchRef: I,
      onConfirm: (H) => {
        qe(H), V();
      },
      onClose: V
    }
  ));
}
const oa = 864e5;
function Xi(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Xi(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function gt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / oa);
}
function zi(e) {
  const t = new Date(e * oa);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function An(e, t) {
  return zi(gt(e) + t);
}
function sa(e) {
  return new Date(gt(e) * oa).getUTCDay();
}
const ka = "1900-01-01", wa = "2099-12-31", qn = ["일", "월", "화", "수", "목", "금", "토"], gn = (e) => String(e).padStart(2, "0");
function nt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${gn(t)}-${gn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Fi(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Jt(e, t) {
  return t === "month" ? Fi(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${gn(e.m)}` : nt(e.y, e.m, e.d);
}
function Re(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function ln(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function Et(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function Wi(e, t, a) {
  return e >= t && e <= a;
}
function Rt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Rn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function Na(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function yn(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function Hi(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return yn(r.replace(/\D/g, ""), t, a);
}
function Ki(e, t) {
  const a = { y: e, m: t, d: 1 }, r = ln(a, -Re(a));
  return Array.from({ length: 42 }, (o, s) => ln(r, s));
}
function Ui(e, t) {
  const a = e.y, r = [], o = (m, u) => `${String(m).padStart(4, "0")}-${gn(u)}`, s = (m, u, d) => nt(m, u, d);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const m = Et(e, -1);
    r.push({ label: "지난달", from: o(m.y, m.m), to: o(m.y, m.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: o(a, u * 3 - 2), to: o(a, u * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = nt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = ln(e, -Re(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(ln(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = Et({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, Le(a, m * 3)) });
  return r;
}
const Yi = "_wrap_uxy72_1", Gi = "_disabled_uxy72_18", Vi = "_input_uxy72_22", Ji = "_month_uxy72_36", Qi = "_weekday_uxy72_39", Zi = "_sun_uxy72_40", eu = "_sat_uxy72_41", tu = "_icon_uxy72_43", nu = "_readOnly_uxy72_57", au = "_required_uxy72_62", ru = "_invalid_uxy72_63", ou = "_pop_uxy72_66", su = "_calHead_uxy72_79", lu = "_calTitleStatic_uxy72_80", cu = "_calTitle_uxy72_80", iu = "_grid_uxy72_90", uu = "_wd_uxy72_91", mu = "_day_uxy72_95", du = "_mon_uxy72_36", fu = "_out_uxy72_104", _u = "_sel_uxy72_105", pu = "_today_uxy72_108", yu = "_months_uxy72_111", bu = "_foot_uxy72_114", hu = "_clear_uxy72_127", gu = "_range_uxy72_130", Eu = "_tilde_uxy72_131", vu = "_rangeErr_uxy72_132", re = {
  wrap: Yi,
  disabled: Gi,
  input: Vi,
  month: Ji,
  weekday: Qi,
  sun: Zi,
  sat: eu,
  icon: tu,
  readOnly: nu,
  required: au,
  invalid: ru,
  pop: ou,
  calHead: su,
  calTitleStatic: lu,
  calTitle: cu,
  grid: iu,
  wd: uu,
  day: mu,
  mon: du,
  out: fu,
  sel: _u,
  today: pu,
  months: yu,
  foot: bu,
  clear: hu,
  range: gu,
  tilde: Eu,
  rangeErr: vu
}, pt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function $a({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: d,
  id: p,
  name: _,
  onBlur: y,
  "aria-label": f,
  "aria-describedby": b,
  className: $ = "",
  style: k
}) {
  const w = a === "month", x = Yt("axe-dp"), E = r || (w ? ka.slice(0, 7) : ka), g = o || (w ? wa.slice(0, 7) : wa), h = (M) => Wi(M, E, g), N = !!s || !!l, [D, j] = S(e || ""), [B, R] = S(!1), [T, P] = S(!1), [ee, F] = S(w ? "month" : "day"), [L, ae] = S(() => {
    var W;
    const M = (W = Jt(e, a)) != null ? W : pt();
    return { y: M.y, m: M.m };
  }), [te, v] = S({ top: 0, left: 0 }), I = q(null), Y = q(null), Z = q(null), A = q(null);
  G(() => {
    j(e || ""), R(!1);
  }, [e]), G(() => {
    const M = Jt(e, a);
    M && ae({ y: M.y, m: M.m });
  }, [e, a]), je(() => {
    const M = Y.current;
    A.current != null && M && document.activeElement === M && M.setSelectionRange(A.current, A.current), A.current = null;
  }, [D]), je(() => {
    if (!T) return;
    const M = () => {
      const W = I.current, oe = Z.current;
      if (!W || !oe) return;
      const ce = W.getBoundingClientRect(), me = oe.offsetHeight, ge = oe.offsetWidth;
      let De = ce.bottom + 4;
      De + me > window.innerHeight - 8 && ce.top - me - 4 > 8 && (De = ce.top - me - 4);
      const Gt = Math.max(8, Math.min(ce.left, window.innerWidth - ge - 8));
      v((jn) => jn.top === De && jn.left === Gt ? jn : { top: De, left: Gt });
    };
    return M(), window.addEventListener("resize", M), window.addEventListener("scroll", M, !0), () => {
      window.removeEventListener("resize", M), window.removeEventListener("scroll", M, !0);
    };
  }, [T, ee, L.y, L.m]), G(() => {
    if (!T) return;
    const M = (W) => {
      var ce, me;
      const oe = W.target;
      (ce = I.current) != null && ce.contains(oe) || (me = Z.current) != null && me.contains(oe) || P(!1);
    };
    return document.addEventListener("mousedown", M), () => document.removeEventListener("mousedown", M);
  }, [T]);
  const V = (M) => {
    M !== (e || "") && t(M);
  }, J = (M) => {
    j(M), R(!1), V(M);
  }, X = () => {
    const M = Rt(D, a);
    if (!M) return;
    const W = yn(M, a, pt()), oe = W ? Be(W, a) : null;
    if (oe && h(oe)) {
      J(oe);
      return;
    }
    u == null || u(D, oe ? "range" : "format"), j(e || ""), R(!1);
  }, z = (M, W) => {
    const oe = Rt(M.slice(0, W), a).length, ce = Rt(M, a), me = Rn(ce, a);
    if (A.current = Na(me, Math.min(oe, ce.length)), j(me), !ce) {
      R(!1), V("");
      return;
    }
    if (ce.length === (w ? 6 : 8)) {
      const ge = yn(ce, a, pt()), De = ge ? Be(ge, a) : null;
      De && h(De) ? (R(!1), V(De)) : R(!0);
    } else R(!1);
  }, O = (M, W) => {
    var Gt;
    const oe = pt(), ce = Rt(D, a), me = (Gt = yn(ce, a, oe)) != null ? Gt : Jt(e, a);
    let ge;
    me ? w ? ge = Et(me, M === "year" ? 12 * W : W) : M === "day" ? ge = ln(me, W) : ge = Et(me, M === "month" ? W : 12 * W) : ge = oe;
    const De = Be(ge, a);
    h(De) && J(De);
  }, K = (M) => {
    var W;
    J(M), P(!1), (W = Y.current) == null || W.focus();
  }, Q = () => {
    var W;
    if (N) return;
    const M = (W = Jt(e, a)) != null ? W : pt();
    ae({ y: M.y, m: M.m }), F(w ? "month" : "day"), P(!0);
  }, Ne = (M) => {
    var oe, ce;
    if (N) return;
    const W = M.currentTarget;
    switch (M.key) {
      case "Escape":
        T ? (P(!1), M.preventDefault(), M.stopPropagation(), M.nativeEvent.stopImmediatePropagation()) : D !== (e || "") && (j(e || ""), R(!1), M.preventDefault(), M.stopPropagation(), M.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => W.select()));
        break;
      case "ArrowDown":
        M.preventDefault(), M.altKey ? T ? P(!1) : Q() : O("day", 1);
        break;
      case "ArrowUp":
        M.preventDefault(), O("day", -1);
        break;
      case "PageDown":
        M.preventDefault(), O("month", 1);
        break;
      case "PageUp":
        M.preventDefault(), O("month", -1);
        break;
      case "F2":
      case "F4":
        M.preventDefault(), T ? P(!1) : Q();
        break;
      case "Enter":
        X(), T && P(!1);
        break;
      case "t":
      case "T":
        if (M.ctrlKey || M.metaKey || M.altKey) break;
        M.preventDefault(), J(Be(pt(), a));
        break;
      case "Backspace": {
        const me = (oe = W.selectionStart) != null ? oe : 0;
        if (me === ((ce = W.selectionEnd) != null ? ce : 0) && me > 0 && D[me - 1] === "-") {
          M.preventDefault();
          const ge = Rt(D.slice(0, me), a).length, De = Rt(D, a);
          z(Rn(De.slice(0, ge - 1) + De.slice(ge), a), 0), A.current = Na(Rn(De.slice(0, ge - 1) + De.slice(ge), a), ge - 1);
        }
        break;
      }
    }
  }, He = (M) => {
    if (N) return;
    M.preventDefault();
    const W = Hi(M.clipboardData.getData("text"), a, pt()), oe = W ? Be(W, a) : null;
    oe && h(oe) ? J(oe) : R(!0);
  }, qe = (M) => {
    var oe, ce;
    const W = M.relatedTarget;
    W && ((oe = I.current) != null && oe.contains(W) || (ce = Z.current) != null && ce.contains(W)) || (X(), P(!1), y && y());
  }, ue = Jt(e, a), Oe = pt(), jt = B || !!i, at = m && !w && ue ? Re(ue) : null, Pe = (M) => Be(M, a), Bn = (M, W) => {
    const oe = Be({ y: M, m: W, d: 1 }, "date"), ce = Be({ y: M, m: W, d: Le(M, W) }, "date"), me = w ? E + "-01" : E, ge = w ? g + "-31" : g;
    return ce >= me && oe <= ge;
  }, Xe = (M) => {
    const W = Et({ y: L.y, m: L.m, d: 1 }, M);
    ae({ y: W.y, m: W.m });
  }, mn = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Xe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Xe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.calTitle, "aria-label": "연·월 선택", onClick: () => F("month") }, L.y, "년 ", L.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Xe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Xe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.grid }, qn.map((M, W) => /* @__PURE__ */ n.createElement("span", { key: M, className: [re.wd, W === 0 ? re.sun : "", W === 6 ? re.sat : ""].join(" ") }, M)), Ki(L.y, L.m).map((M) => {
    const W = Be(M, "date"), oe = Re(M), ce = [
      re.day,
      M.m !== L.m ? re.out : "",
      oe === 0 ? re.sun : "",
      oe === 6 ? re.sat : "",
      W === Be(Oe, "date") ? re.today : "",
      ue && W === Be(ue, "date") ? re.sel : ""
    ].join(" "), me = !h(W);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: W,
        type: "button",
        tabIndex: -1,
        className: ce,
        disabled: me,
        "aria-label": `${M.y}년 ${M.m}월 ${M.d}일 ${qn[oe]}요일`,
        "aria-pressed": !!ue && W === Be(ue, "date"),
        onClick: () => K(W)
      },
      M.d
    );
  }))), H = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Xe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: re.calTitleStatic }, L.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Xe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.months }, Array.from({ length: 12 }, (M, W) => W + 1).map((M) => {
    const W = !!ue && ue.y === L.y && ue.m === M, oe = [re.mon, W ? re.sel : "", Oe.y === L.y && Oe.m === M ? re.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: M,
        type: "button",
        tabIndex: -1,
        className: oe,
        disabled: !Bn(L.y, M),
        "aria-pressed": W,
        onClick: () => {
          w ? K(Pe({ y: L.y, m: M, d: 1 })) : (ae({ y: L.y, m: M }), F("day"));
        }
      },
      M,
      "월"
    );
  }))), fe = Be(Oe, a), ze = w ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !h(fe), onClick: () => K(fe) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !h(fe), onClick: () => K(fe) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Pe({ y: L.y, m: L.m, d: 1 })),
      onClick: () => K(Pe({ y: L.y, m: L.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Pe({ y: L.y, m: L.m, d: Le(L.y, L.m) })),
      onClick: () => K(Pe({ y: L.y, m: L.m, d: Le(L.y, L.m) }))
    },
    "월말"
  )), Lt = [
    re.wrap,
    s ? re.disabled : "",
    l ? re.readOnly : "",
    c && !e && !D ? re.required : "",
    jt ? re.invalid : "",
    w ? re.month : "",
    $
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: I, className: Lt, style: k, onBlur: qe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: Y,
      id: p,
      name: _,
      className: re.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: D,
      placeholder: d != null ? d : w ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": T,
      "aria-controls": x,
      "aria-label": f,
      "aria-describedby": b,
      "aria-invalid": jt || void 0,
      "aria-required": c || void 0,
      onChange: (M) => {
        var W;
        return z(M.target.value, (W = M.target.selectionStart) != null ? W : M.target.value.length);
      },
      onKeyDown: Ne,
      onPaste: He
    }
  ), at != null && /* @__PURE__ */ n.createElement("span", { className: [re.weekday, at === 0 ? re.sun : "", at === 6 ? re.sat : ""].join(" "), "aria-hidden": "true" }, "(", qn[at], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: re.icon,
      disabled: N,
      "aria-label": w ? "월 선택 열기" : "달력 열기",
      onMouseDown: (M) => M.preventDefault(),
      onClick: () => {
        var M;
        (M = Y.current) == null || M.focus(), T ? P(!1) : Q();
      }
    },
    /* @__PURE__ */ n.createElement(hn, { name: "calendar", size: 15 })
  ), T && /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Z,
      id: x,
      className: re.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": w ? "월 선택" : "날짜 선택",
      onMouseDown: (M) => M.preventDefault()
    },
    ee === "day" && !w ? mn() : H(),
    /* @__PURE__ */ n.createElement("div", { className: re.foot }, ze, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.clear, onClick: () => K("") }, "비우기"))
  )));
}
const At = (e) => String(e).padStart(2, "0");
function yr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${At(e.getMonth() + 1)}-${At(e.getDate())}`;
}
function o0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${At(t.getMonth() + 1)}-${At(t.getDate())} ${At(t.getHours())}:${At(t.getMinutes())}:${At(t.getSeconds())}`;
}
function s0(e, t) {
  return !!e && !!t && e <= t;
}
function l0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const d = !!e && !!t && e > t, p = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : Ui({ y: p.getFullYear(), m: p.getMonth() + 1, d: p.getDate() }, r), y = (f) => (!o || f.from >= o) && (!s || f.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: re.range }, /* @__PURE__ */ n.createElement(
    $a,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (f) => a(f, t),
      onReject: u && ((f, b) => u(f, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: re.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    $a,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (f) => a(e, f),
      onReject: u && ((f, b) => u(f, b, "to"))
    }
  ), _.length > 0 && /* @__PURE__ */ n.createElement(
    qo,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: _.map((f) => Lo(
        f.label,
        f.label,
        () => a(f.from, f.to),
        y(f) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), d && /* @__PURE__ */ n.createElement("span", { className: re.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const br = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function hr(e, t = br) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function ku(e, t = {}) {
  const a = hr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function c0(e, t) {
  const a = hr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, En = (e) => String(e).padStart(2, "0");
function ye(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function St(e) {
  const t = new Date(e * 6e4);
  return nt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function nn(e) {
  const t = new Date(e * 6e4);
  return `${St(e)}T${En(t.getUTCHours())}:${En(t.getUTCMinutes())}`;
}
function et(e) {
  const t = (e % Se + Se) % Se;
  return `${En(Math.floor(t / 60))}:${En(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? An(e, t) : e;
}
function Ht(e, t) {
  return Math.round((ye(t) - ye(e)) / Se);
}
function cn(e) {
  if (!de(e)) return !1;
  const t = sa(e);
  return t === 0 || t === 6;
}
function wu(e) {
  var o;
  const t = ye(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = St(t), l = e.end ? St(ye(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: ye(s), e: ye(c) + Se, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? ye(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: St(t), eDay: St(r - 1) };
}
function Cn(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = wu(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(Nu);
}
function Nu(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Ht(t.sDay, t.eDay) - Ht(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function $u(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function gr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function vn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Re(a) - t + 7) % 7;
  return ke(e, -r);
}
function Sn(e, t) {
  const a = Ht(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => ke(e, o));
}
function Er(e, t) {
  const a = de(e), r = nt(a.y, a.m, 1), o = nt(a.y, a.m, Le(a.y, a.m)), s = vn(r, t), l = ke(vn(o, t), 6), c = Sn(s, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function la(e, t, a) {
  if (e === "month") {
    const r = Er(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: nt(r.y, r.m, 1), to: nt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = vn(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function xu(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = Et(o, a);
    return nt(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let s = ke(t, a);
  for (; r && cn(s); ) s = ke(s, a);
  return s;
}
function Du(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = la("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function vr(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function Au(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const Cu = 20;
function Su(e, t) {
  const a = ye(t), r = a + Se, o = e.filter((m) => !gr(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of o) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Cu);
    let d = l.findIndex((p) => p <= m.top);
    d < 0 ? (d = l.length, l.push(u)) : l[d] = u, m.col = d, s.push(m), c = Math.max(c, u);
  }
  return i(), o;
}
function xa(e, t) {
  return Math.round(e / t) * t;
}
function Vn(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: nn(e.s + t), end: nn(e.e + t) };
}
function ca(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = ye(e.sDay), r = et(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : et(e.e - a)}`;
  const o = de(e.sDay), s = de(St(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${et(e.e - ye(St(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: Re(t) };
};
function Da(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = ku(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function Mu(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : br, o = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], d = (_) => Da(_, a, "年", r, o), p = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (_) => `前の${p[_]} (P)`,
      next: (_) => `次の${p[_]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (_) => `他${_}件`,
      eventCount: (_) => `予定${_}件`,
      dayOfSpan: (_, y) => `${_}/${y}日目`,
      openDay: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: d,
      ym: (_) => `${d(_)}${Ae(_).m}月`,
      ymd: (_) => {
        const y = Ae(_);
        return `${d(_)}${y.m}月${y.d}日`;
      },
      md: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日`;
      },
      d: (_) => `${Ae(_).d}日`,
      m: (_) => `${Ae(_).m}月`,
      dayTitle: (_) => {
        const y = Ae(_);
        return `${d(_)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => Da(u, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, d) => `${u}/${d}일째`,
    openDay: (u) => {
      const d = Ae(u);
      return `${d.m}월 ${d.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ae(u).m}월`,
    ymd: (u) => {
      const d = Ae(u);
      return `${l(u)} ${d.m}월 ${d.d}일`;
    },
    md: (u) => {
      const d = Ae(u);
      return `${d.m}월 ${d.d}일`;
    },
    d: (u) => `${Ae(u).d}일`,
    m: (u) => `${Ae(u).m}월`,
    dayTitle: (u) => {
      const d = Ae(u);
      return `${l(u)} ${d.m}월 ${d.d}일 (${s[d.w]})`;
    },
    dayAria: (u) => {
      const d = Ae(u);
      return `${d.m}월 ${d.d}일 ${s[d.w]}요일`;
    }
  };
}
const kr = Mu("ko"), Tu = "_cal_ooj0g_2", Bu = "_toolbar_ooj0g_20", ju = "_navBtns_ooj0g_28", Lu = "_title_ooj0g_29", qu = "_toolRight_ooj0g_36", Ru = "_toggle_ooj0g_37", Iu = "_body_ooj0g_58", Ou = "_busy_ooj0g_59", Pu = "_sun_ooj0g_71", Xu = "_sat_ooj0g_72", zu = "_tAccent_ooj0g_75", Fu = "_tOk_ooj0g_76", Wu = "_tWarn_ooj0g_77", Hu = "_tDanger_ooj0g_78", Ku = "_tViolet_ooj0g_79", Uu = "_tGray_ooj0g_80", Yu = "_month_ooj0g_83", Gu = "_mHead_ooj0g_84", Vu = "_wdName_ooj0g_85", Ju = "_mBody_ooj0g_91", Qu = "_mWeek_ooj0g_92", Zu = "_mCells_ooj0g_94", em = "_cell_ooj0g_96", tm = "_out_ooj0g_104", nm = "_dayNum_ooj0g_105", am = "_creatable_ooj0g_106", rm = "_selDay_ooj0g_109", om = "_cellHead_ooj0g_111", sm = "_isToday_ooj0g_124", lm = "_holiday_ooj0g_125", cm = "_addHint_ooj0g_130", im = "_barLayer_ooj0g_138", um = "_chip_ooj0g_139", mm = "_more_ooj0g_139", dm = "_tEv_ooj0g_155", fm = "_aRow_ooj0g_155", _m = "_popItem_ooj0g_155", pm = "_bar_ooj0g_138", ym = "_contL_ooj0g_165", bm = "_contR_ooj0g_166", hm = "_dotChip_ooj0g_167", gm = "_dot_ooj0g_167", Em = "_chipTime_ooj0g_170", vm = "_chipTitle_ooj0g_171", km = "_movable_ooj0g_173", wm = "_ghost_ooj0g_176", Nm = "_time_ooj0g_189", $m = "_tHead_ooj0g_190", xm = "_tAllDay_ooj0g_190", Dm = "_gutter_ooj0g_193", Am = "_tHeadDays_ooj0g_197", Cm = "_tAllDayCells_ooj0g_197", Sm = "_tDay_ooj0g_198", Mm = "_tDayBtn_ooj0g_202", Tm = "_tWd_ooj0g_206", Bm = "_tDayNum_ooj0g_208", jm = "_tAllDayRow_ooj0g_216", Lm = "_allDayCell_ooj0g_218", qm = "_tBody_ooj0g_222", Rm = "_tGrid_ooj0g_223", Im = "_tGutter_ooj0g_224", Om = "_tCols_ooj0g_230", Pm = "_tCol_ooj0g_230", Xm = "_tSel_ooj0g_238", zm = "_tEvTitle_ooj0g_258", Fm = "_tEvTime_ooj0g_259", Wm = "_tEvShort_ooj0g_261", Hm = "_contTop_ooj0g_263", Km = "_contBottom_ooj0g_264", Um = "_resize_ooj0g_265", Ym = "_now_ooj0g_268", Gm = "_agenda_ooj0g_272", Vm = "_aDay_ooj0g_273", Jm = "_aDate_ooj0g_275", Qm = "_aDateBtn_ooj0g_276", Zm = "_aDayNum_ooj0g_280", ed = "_aDayWd_ooj0g_286", td = "_aList_ooj0g_288", nd = "_aTime_ooj0g_295", ad = "_aTitle_ooj0g_296", rd = "_aSpan_ooj0g_297", od = "_aLoc_ooj0g_298", sd = "_empty_ooj0g_303", ld = "_pop_ooj0g_155", cd = "_popHead_ooj0g_321", id = "_popDay_ooj0g_322", ud = "_popClose_ooj0g_329", md = "_popList_ooj0g_334", C = {
  cal: Tu,
  toolbar: Bu,
  navBtns: ju,
  title: Lu,
  toolRight: qu,
  toggle: Ru,
  body: Iu,
  busy: Ou,
  sun: Pu,
  sat: Xu,
  tAccent: zu,
  tOk: Fu,
  tWarn: Wu,
  tDanger: Hu,
  tViolet: Ku,
  tGray: Uu,
  month: Yu,
  mHead: Gu,
  wdName: Vu,
  mBody: Ju,
  mWeek: Qu,
  mCells: Zu,
  cell: em,
  out: tm,
  dayNum: nm,
  creatable: am,
  selDay: rm,
  cellHead: om,
  isToday: sm,
  holiday: lm,
  addHint: cm,
  barLayer: im,
  chip: um,
  more: mm,
  tEv: dm,
  aRow: fm,
  popItem: _m,
  bar: pm,
  contL: ym,
  contR: bm,
  dotChip: hm,
  dot: gm,
  chipTime: Em,
  chipTitle: vm,
  movable: km,
  ghost: wm,
  time: Nm,
  tHead: $m,
  tAllDay: xm,
  gutter: Dm,
  tHeadDays: Am,
  tAllDayCells: Cm,
  tDay: Sm,
  tDayBtn: Mm,
  tWd: Tm,
  tDayNum: Bm,
  tAllDayRow: jm,
  allDayCell: Lm,
  tBody: qm,
  tGrid: Rm,
  tGutter: Im,
  tCols: Om,
  tCol: Pm,
  tSel: Xm,
  tEvTitle: zm,
  tEvTime: Fm,
  tEvShort: Wm,
  contTop: Hm,
  contBottom: Km,
  resize: Um,
  now: Ym,
  agenda: Gm,
  aDay: Vm,
  aDate: Jm,
  aDateBtn: Qm,
  aDayNum: Zm,
  aDayWd: ed,
  aList: td,
  aTime: nd,
  aTitle: ad,
  aSpan: rd,
  aLoc: od,
  empty: sd,
  pop: ld,
  popHead: cd,
  popDay: id,
  popClose: ud,
  popList: md
}, kn = 22, dd = {
  accent: C.tAccent,
  ok: C.tOk,
  warn: C.tWarn,
  danger: C.tDanger,
  violet: C.tViolet,
  gray: C.tGray
};
function Mn(e) {
  var t;
  return e.color ? "" : dd[(t = e.tone) != null ? t : "accent"];
}
function Tn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function wr(e, t) {
  return [e.ev.title, ca(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const an = (e, t) => !!e.onEventChange && !t.locked;
function bn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function wn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (u) => {
    !o && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (o = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, o);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Nr(e) {
  const [t, a] = S(null), [r, o] = S(null), s = q(!1);
  return { preview: t, items: (d, p) => Cn(e.events, d, p, t), onItemDown: (d, p) => {
    var f;
    if (d.button !== 0 || !an(e, p.ev)) return;
    const _ = (f = bn(d.clientX, d.clientY, "data-cal-day")) == null ? void 0 : f.dataset.calDay;
    if (!_) return;
    s.current = !1;
    let y = 0;
    wn(d, {
      move: (b) => {
        var k;
        s.current = !0;
        const $ = (k = bn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : k.dataset.calDay;
        $ && (y = Ht(_, $), a({ id: p.ev.id, ...Vn(p, y * Se) }));
      },
      end: (b, $) => {
        var k;
        a(null), $ && y && ((k = e.onEventChange) == null || k.call(e, p.ev, Vn(p, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (d, p) => {
    if (d.button !== 0 || !e.onCreate) return;
    d.preventDefault();
    let _ = p;
    o({ a: p, b: p }), wn(d, {
      move: (y) => {
        var b;
        const f = (b = bn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        f && (_ = f, o({ a: p, b: f }));
      },
      end: () => {
        var b;
        o(null);
        const [y, f] = p <= _ ? [p, _] : [_, p];
        (b = e.onCreate) == null || b.call(e, { start: y, end: f, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (d, p) => {
    var _;
    if (s.current) {
      s.current = !1;
      return;
    }
    (_ = e.onEventClick) == null || _.call(e, p, d);
  }, inSel: (d) => !!r && d >= (r.a < r.b ? r.a : r.b) && d <= (r.a < r.b ? r.b : r.a) };
}
function $r({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: C.barLayer }, e.map((s) => {
    var d;
    const l = s.item, c = l.ev, i = $u(l), m = et(l.s - ye(l.sDay)), u = [
      C.chip,
      i ? C.bar : C.dotChip,
      Mn(c),
      s.contL ? C.contL : "",
      s.contR ? C.contR : "",
      ((d = o.preview) == null ? void 0 : d.id) === c.id ? C.ghost : "",
      an(r, c) ? C.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * kn,
          ...Tn(c)
        },
        "aria-label": wr(l, r.L),
        onPointerDown: (p) => o.onItemDown(p, l),
        onClick: (p) => o.clickItem(p.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, c.title))
    );
  }));
}
const In = 26;
function fd({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => Er(a, o).map((x) => s ? x : x.filter((E) => !cn(E))),
    [a, o, s]
  ), m = i[0].length, u = Nr(e), d = u.items(i[0][0], i[i.length - 1][m - 1]), p = q(null), [_, y] = S(0);
  je(() => {
    const x = p.current;
    if (!x) return;
    const E = () => y(x.clientHeight / i.length);
    if (E(), typeof ResizeObserver == "undefined") return;
    const g = new ResizeObserver(E);
    return g.observe(x), () => g.disconnect();
  }, [i.length]);
  const f = _ ? Math.max(1, Math.floor((_ - In - 4) / kn)) : 3, b = q(!1), $ = q(null);
  G(() => {
    var x, E;
    b.current && (b.current = !1, (E = (x = $.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || E.focus());
  }, [a, c]);
  const k = (x, E) => {
    let g = ke(x, E);
    for (; !s && cn(g); ) g = ke(g, E > 0 ? 1 : -1);
    return g;
  }, w = (x, E, g) => {
    let h = null;
    if (x.key === "ArrowLeft") h = k(E, -1);
    else if (x.key === "ArrowRight") h = k(E, 1);
    else if (x.key === "ArrowUp") h = k(E, -7);
    else if (x.key === "ArrowDown") h = k(E, 7);
    else if (x.key === "Home") h = g[0];
    else if (x.key === "End") h = g[g.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", E);
      return;
    }
    h && (x.preventDefault(), b.current = !0, e.setCursor(h));
  };
  return /* @__PURE__ */ n.createElement("div", { className: C.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: $ }, /* @__PURE__ */ n.createElement("div", { className: C.mHead, role: "row" }, i[0].map((x) => {
    const E = Re(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [C.wdName, E === 0 ? C.sun : "", E === 6 ? C.sat : ""].join(" ") }, t.weekdays[E]);
  })), /* @__PURE__ */ n.createElement("div", { className: C.mBody, ref: p }, i.map((x) => {
    const { shown: E, more: g } = Au(vr(d, x), m, f);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: C.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: C.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((h) => {
      const N = de(h), D = Re(N), j = l[h], B = d.filter((T) => T.sDay <= h && T.eDay >= h).length, R = [
        C.cell,
        h.slice(0, 7) !== c ? C.out : "",
        D === 0 || j ? C.sun : D === 6 ? C.sat : "",
        h === r ? C.isToday : "",
        u.inSel(h) ? C.selDay : "",
        e.onCreate ? C.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: h,
          role: "gridcell",
          "data-cal-day": h,
          tabIndex: h === a ? 0 : -1,
          "aria-selected": h === a,
          "aria-current": h === r ? "date" : void 0,
          "aria-label": `${t.dayAria(h)}${j ? ` ${j}` : ""}, ${t.eventCount(B)}`,
          className: R,
          onPointerDown: (T) => u.onCellDown(T, h),
          onKeyDown: (T) => w(T, h, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: C.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: C.dayNum,
            "aria-label": t.openDay(h),
            onPointerDown: (T) => T.stopPropagation(),
            onClick: () => e.goto("day", h)
          },
          N.d === 1 ? t.md(h) : N.d
        ), j && /* @__PURE__ */ n.createElement("span", { className: C.holiday, title: j }, j), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: C.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement($r, { segs: E, cols: m, top: In, ctx: e, drag: u }), g.map((h, N) => h > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[N],
        type: "button",
        className: C.more,
        style: {
          left: `calc(${N / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: In + (f - 1) * kn
        },
        onClick: (D) => e.openMore(x[N], D.currentTarget)
      },
      t.more(h)
    ) : null));
  })));
}
const Qe = 44, _d = Array.from({ length: 23 }, (e, t) => t + 1);
function Aa() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function On(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Qe * 60));
}
function Ca({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = Nr(e), [s, l] = S(null), [c, i] = S(null), m = q(!1), u = Cn(e.events, t[0], t[a - 1], s != null ? s : o.preview), d = vr(u.filter(gr), t), p = d.reduce((E, g) => Math.max(E, g.lane + 1), 0), _ = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, f] = S(Aa);
  G(() => {
    const E = window.setInterval(() => f(Aa()), 6e4);
    return () => window.clearInterval(E);
  }, []);
  const b = q(null), $ = t.includes(e.today);
  je(() => {
    const E = b.current;
    if (!E) return;
    const g = $ ? Math.max(0, Math.floor((y - ye(e.today)) / 60) - 1) : e.scrollToHour;
    E.scrollTop = g * Qe;
  }, [t[0], a]);
  const k = (E, g) => {
    if (E.button !== 0 || !e.onCreate) return;
    E.preventDefault();
    const h = E.currentTarget, N = Math.min(Se - r, Math.floor(On(E.clientY, h) / r) * r);
    let D = N;
    i({ day: g, a: N, b: N + r }), wn(E, {
      move: (j) => {
        D = Math.min(Se - r, Math.floor(On(j.clientY, h) / r) * r), i({ day: g, a: Math.min(N, D), b: Math.max(N, D) + r });
      },
      end: (j, B) => {
        var ee;
        i(null);
        const R = ye(g), T = B ? Math.min(N, D) : N, P = B ? Math.max(N, D) + r : Math.min(N + 60, Se);
        (ee = e.onCreate) == null || ee.call(e, { start: nn(R + T), end: nn(R + P), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, w = (E, g, h) => {
    if (E.stopPropagation(), E.button !== 0 || !an(e, g.ev)) return;
    const N = (B, R) => {
      const T = bn(B, R, "data-cal-col");
      return T ? ye(T.dataset.calCol) + On(R, T) : null;
    }, D = N(E.clientX, E.clientY);
    if (D == null) return;
    m.current = !1;
    let j = null;
    wn(E, {
      move: (B) => {
        m.current = !0;
        const R = N(B.clientX, B.clientY);
        if (R != null) {
          if (h === "move") {
            const T = xa(R - D, r);
            j = T ? Vn(g, T) : null;
          } else {
            const T = Math.max(g.s + r, xa(R, r));
            j = T !== g.e ? { start: g.ev.start, end: nn(T) } : null;
          }
          l(j ? { id: g.ev.id, ...j } : null);
        }
      },
      end: (B, R) => {
        var T;
        l(null), R && j && ((T = e.onEventChange) == null || T.call(e, g.ev, j));
      },
      cancel: () => l(null)
    });
  }, x = (E, g) => {
    var h;
    if (m.current) {
      m.current = !1;
      return;
    }
    (h = e.onEventClick) == null || h.call(e, g, E);
  };
  return /* @__PURE__ */ n.createElement("div", { className: C.time }, /* @__PURE__ */ n.createElement("div", { className: C.tHead }, /* @__PURE__ */ n.createElement("div", { className: C.gutter }), /* @__PURE__ */ n.createElement("div", { className: C.tHeadDays, style: _ }, t.map((E) => {
    const g = de(E), h = Re(g), N = e.holidays[E];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        className: [C.tDay, E === e.today ? C.isToday : "", h === 0 || N ? C.sun : h === 6 ? C.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: C.tDayBtn, onClick: () => e.goto("day", E), "aria-label": e.L.openDay(E) }, /* @__PURE__ */ n.createElement("span", { className: C.tWd }, e.L.weekdays[h]), /* @__PURE__ */ n.createElement("span", { className: C.tDayNum }, g.d)),
      N && /* @__PURE__ */ n.createElement("span", { className: C.holiday, title: N }, N)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: C.tAllDay }, /* @__PURE__ */ n.createElement("div", { className: C.gutter }, e.L.allDay), /* @__PURE__ */ n.createElement("div", { className: C.tAllDayRow, style: { height: Math.max(1, p) * kn + 6 } }, /* @__PURE__ */ n.createElement("div", { className: C.tAllDayCells, style: _ }, t.map((E) => /* @__PURE__ */ n.createElement(
    "div",
    {
      key: E,
      "data-cal-day": E,
      className: [C.allDayCell, o.inSel(E) ? C.selDay : "", e.onCreate ? C.creatable : ""].join(" "),
      onPointerDown: (g) => o.onCellDown(g, E)
    }
  ))), /* @__PURE__ */ n.createElement($r, { segs: d, cols: a, top: 3, ctx: e, drag: o }))), /* @__PURE__ */ n.createElement("div", { className: C.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: C.tGrid, style: { height: 24 * Qe } }, /* @__PURE__ */ n.createElement("div", { className: C.tGutter, "aria-hidden": !0 }, _d.map((E) => /* @__PURE__ */ n.createElement("span", { key: E, style: { top: E * Qe } }, et(E * 60)))), /* @__PURE__ */ n.createElement("div", { className: C.tCols, style: { ..._, backgroundSize: `100% ${Qe}px` } }, t.map((E) => {
    const g = Su(u, E);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-col": E,
        className: [C.tCol, E === e.today ? C.isToday : "", e.onCreate ? C.creatable : ""].join(" "),
        onPointerDown: (h) => k(h, E)
      },
      (c == null ? void 0 : c.day) === E && /* @__PURE__ */ n.createElement("div", { className: C.tSel, style: { top: c.a / 60 * Qe, height: (c.b - c.a) / 60 * Qe } }, et(c.a), " – ", c.b === Se ? "24:00" : et(c.b)),
      g.map((h) => {
        const N = h.item.ev, D = (h.bottom - h.top) / 60 * Qe, j = [
          C.tEv,
          Mn(N),
          D < 34 ? C.tEvShort : "",
          h.contTop ? C.contTop : "",
          h.contBottom ? C.contBottom : "",
          (s == null ? void 0 : s.id) === N.id ? C.ghost : "",
          an(e, N) ? C.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: N.id,
            type: "button",
            className: j,
            style: {
              top: h.top / 60 * Qe,
              height: Math.max(18, D - 1),
              left: `calc(${h.col / h.cols * 100}% + 1px)`,
              width: `calc(${100 / h.cols}% - 4px)`,
              ...Tn(N)
            },
            "aria-label": wr(h.item, e.L),
            onPointerDown: (B) => w(B, h.item, "move"),
            onClick: (B) => x(B.currentTarget, N)
          },
          /* @__PURE__ */ n.createElement("span", { className: C.tEvTitle }, N.title),
          /* @__PURE__ */ n.createElement("span", { className: C.tEvTime }, ca(h.item, e.L.allDay)),
          an(e, N) && !h.contBottom && /* @__PURE__ */ n.createElement("span", { className: C.resize, "aria-hidden": !0, onPointerDown: (B) => w(B, h.item, "resize") })
        );
      }),
      E === e.today && /* @__PURE__ */ n.createElement("div", { className: C.now, style: { top: (y - ye(E)) / 60 * Qe }, "aria-hidden": !0 })
    );
  })))));
}
function Sa(e, t, a) {
  return e.sDay === e.eDay ? ca(e, a) : e.allDay ? a : t === e.sDay ? `${et(e.s - ye(t))} ~` : t === e.eDay ? `~ ${et(e.e - ye(t))}` : a;
}
function pd({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = la("agenda", e.cursor, e.weekStartsOn), o = Cn(e.events, a, r), s = Sn(a, r).filter((l) => e.showWeekends || !cn(l)).map((l) => {
    const c = ye(l), i = (u) => Sa(u, l, "") === "" ? -1 : Math.max(u.s, c), m = o.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, d) => i(u) - i(d)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: C.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Re(i), d = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [C.aDay, l === e.today ? C.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [C.aDate, u === 0 || m ? C.sun : u === 6 ? C.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: C.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: C.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: C.aDayWd }, t.m(l), " · ", d)), m && /* @__PURE__ */ n.createElement("span", { className: C.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: C.aList }, c.map((p) => {
      const _ = p.ev, y = Ht(p.sDay, p.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: _.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [C.aRow, Mn(_)].join(" "),
          style: Tn(_),
          onClick: (f) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, _, f.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: C.aTime }, Sa(p, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: C.aTitle }, _.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: C.aSpan }, t.dayOfSpan(Ht(p.sDay, l) + 1, y))),
        _.location && /* @__PURE__ */ n.createElement("span", { className: C.aLoc }, _.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: C.empty }, t.empty);
}
const Pn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Ma(e, t, a) {
  const [r, o] = S(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const Ta = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function i0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: d,
  slotMinutes: p = 30,
  scrollToHour: _ = 8,
  onRangeChange: y,
  onEventClick: f,
  onCreate: b,
  onEventChange: $,
  locale: k = kr,
  loading: w,
  headerExtra: x,
  className: E = "",
  style: g,
  "aria-label": h
}) {
  var z;
  const N = yr(), [D, j] = Ma(t, (z = a != null ? a : c[0]) != null ? z : "month", r), [B, R] = Ma(o, s != null ? s : N, l), T = de(B) ? B : N, [P, ee] = S(m), [F, L] = S(null), ae = q(null), te = q(!1);
  G(() => {
    var K;
    if (!te.current) return;
    te.current = !1;
    const O = ae.current;
    !O || O.contains(document.activeElement) || ((K = O.querySelector('[data-cal-day][tabindex="0"]')) != null ? K : O).focus();
  });
  const { from: v, to: I } = la(D, T, i), Y = q(y);
  Y.current = y, G(() => {
    var O;
    (O = Y.current) == null || O.call(Y, { from: v, to: I, view: D });
  }, [v, I, D]);
  const Z = (O, K) => {
    R(K), c.includes(O) && j(O);
  }, A = {
    events: e,
    L: k,
    cursor: T,
    today: N,
    weekStartsOn: i,
    showWeekends: P,
    holidays: d != null ? d : {},
    slotMinutes: p,
    scrollToHour: _,
    setCursor: R,
    goto: Z,
    openMore: (O, K) => L({ day: O, anchor: K }),
    onEventClick: f,
    onCreate: b,
    onEventChange: $
  }, V = (O) => R(xu(D, T, O, D === "day" && !P)), J = (O) => {
    if (O.defaultPrevented || O.ctrlKey || O.metaKey || O.altKey || O.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const K = O.nativeEvent.code;
    if (K === "KeyT") R(N);
    else if (K === "KeyN" || K === "KeyJ" || O.key === "PageDown") V(1);
    else if (K === "KeyP" || K === "KeyK" || O.key === "PageUp") V(-1);
    else if (Pn[K] && c.includes(Pn[K])) j(Pn[K]);
    else if (K === "KeyC" && b)
      b(D === "month" || D === "agenda" ? { start: T, end: T, allDay: !0 } : { start: `${T}T09:00`, end: `${T}T10:00`, allDay: !1 });
    else return;
    O.preventDefault(), te.current = !0;
  }, X = we(
    () => Sn(v, I).filter((O) => P || !cn(O)),
    [v, I, P]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [C.cal, E].filter(Boolean).join(" "),
      style: g,
      role: "region",
      "aria-label": h != null ? h : k.region,
      "aria-busy": w || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: J,
      ref: ae,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: C.toolbar }, /* @__PURE__ */ n.createElement(Ft, { onClick: () => R(N), title: `${k.today} (T)` }, k.today), /* @__PURE__ */ n.createElement("span", { className: C.navBtns }, /* @__PURE__ */ n.createElement(Un, { label: k.prev(D), onClick: () => V(-1) }, /* @__PURE__ */ n.createElement(Ta, { dir: "l" })), /* @__PURE__ */ n.createElement(Un, { label: k.next(D), onClick: () => V(1) }, /* @__PURE__ */ n.createElement(Ta, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: C.title, "aria-live": "polite" }, Du(D, T, i, k)), /* @__PURE__ */ n.createElement("span", { className: C.toolRight }, x, u && D !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: C.toggle,
        "aria-pressed": !P,
        onClick: () => ee((O) => !O)
      },
      k.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      or,
      {
        variant: "segmented",
        "aria-label": k.viewTabs,
        items: c.map((O) => ({ key: O, label: k.views[O] })),
        value: D,
        onChange: (O) => j(O)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: C.body }, w && /* @__PURE__ */ n.createElement("div", { className: C.busy, role: "progressbar", "aria-label": k.loading }), D === "month" && /* @__PURE__ */ n.createElement(fd, { ctx: A }), D === "week" && /* @__PURE__ */ n.createElement(Ca, { ctx: A, days: X }), D === "day" && /* @__PURE__ */ n.createElement(Ca, { ctx: A, days: [T] }), D === "agenda" && /* @__PURE__ */ n.createElement(pd, { ctx: A })),
    F && /* @__PURE__ */ n.createElement(yd, { ctx: A, day: F.day, anchor: F.anchor, onClose: () => L(null) })
  );
}
function yd({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = q(null), [s, l] = S({ top: -9999, left: -9999 }), c = de(t), i = Cn(e.events, t, t);
  return je(() => {
    var _;
    const m = o.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), d = m.offsetWidth, p = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - d / 2, window.innerWidth - d - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - p - 8))
    }), (_ = m.querySelector("[data-cal-pop-item]")) == null || _.focus();
  }, [a]), G(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (p) => {
      var _;
      (_ = o.current) != null && _.contains(p.target) || r();
    }, d = (p) => {
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", d, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", d, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Ut, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: C.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: C.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: C.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Re(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: C.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: C.popList }, i.map((m) => {
    const u = m.ev, d = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [C.popItem, d ? C.bar : C.dotChip, Mn(u)].join(" "),
        style: Tn(u),
        onClick: () => {
          var p;
          r(), (p = e.onEventClick) == null || p.call(e, u, a);
        }
      },
      !d && /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, et(Math.max(m.s, ye(t)) - ye(t))),
      /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, u.title)
    ));
  }))));
}
const bd = "_mini_q7p5n_3", hd = "_nav_q7p5n_5", gd = "_navBtn_q7p5n_6", Ed = "_todayBtn_q7p5n_6", vd = "_title_q7p5n_6", kd = "_day_q7p5n_25", wd = "_mon_q7p5n_25", Nd = "_grid_q7p5n_29", $d = "_wdRow_q7p5n_30", xd = "_row_q7p5n_30", Dd = "_sun_q7p5n_35", Ad = "_sat_q7p5n_36", Cd = "_num_q7p5n_45", Sd = "_sel_q7p5n_46", Md = "_out_q7p5n_50", Td = "_isToday_q7p5n_52", Bd = "_dots_q7p5n_55", jd = "_months_q7p5n_59", se = {
  mini: bd,
  nav: hd,
  navBtn: gd,
  todayBtn: Ed,
  title: vd,
  day: kd,
  mon: wd,
  grid: Nd,
  wdRow: $d,
  row: xd,
  sun: Dd,
  sat: Ad,
  num: Cd,
  sel: Sd,
  out: Md,
  isToday: Td,
  dots: Bd,
  months: jd
}, Ba = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function u0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = kr,
  today: m,
  children: u,
  className: d = "",
  "aria-label": p
}) {
  const _ = m != null ? m : yr(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${_.slice(0, 7)}-01`, f = de(y), b = vn(y, c), $ = Sn(b, ke(b, 41)), k = s != null ? s : i.eventCount, [w, x] = S("day"), [E, g] = S(f.y), h = (F) => !!F && F.slice(0, 7) === y.slice(0, 7), [N, D] = S(() => h(a) ? a : h(_) ? _ : y);
  G(() => {
    h(N) || D(h(a) ? a : h(_) ? _ : y);
  }, [y]);
  const j = q(!1), B = q(null);
  G(() => {
    var F, L;
    j.current && (j.current = !1, (L = (F = B.current) == null ? void 0 : F.querySelector(`[data-day="${N}"]`)) == null || L.focus());
  }, [N, y]);
  const R = (F) => {
    j.current = !0, D(F), h(F) || t(F.slice(0, 7));
  }, T = (F) => {
    const L = Et(f, F);
    t(Ba(L.y, L.m));
  }, P = (F, L) => {
    const ae = de(L), te = (Re(ae) - c + 7) % 7;
    let v = null;
    if (F.key === "ArrowLeft") v = ke(L, -1);
    else if (F.key === "ArrowRight") v = ke(L, 1);
    else if (F.key === "ArrowUp") v = ke(L, -7);
    else if (F.key === "ArrowDown") v = ke(L, 7);
    else if (F.key === "Home") v = ke(L, -te);
    else if (F.key === "End") v = ke(L, 6 - te);
    else if (F.key === "PageUp" || F.key === "PageDown") {
      const I = Et(ae, F.key === "PageUp" ? -1 : 1);
      v = nt(I.y, I.m, I.d);
    }
    v && (F.preventDefault(), R(v));
  }, ee = () => {
    g(f.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [se.mini, d].filter(Boolean).join(" "), role: p ? "group" : void 0, "aria-label": p }, w === "day" ? /* @__PURE__ */ n.createElement("div", { className: se.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.prevMonth, onClick: () => T(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: ee }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.nextMonth, onClick: () => T(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: se.todayBtn,
      disabled: h(_),
      onClick: () => {
        t(_.slice(0, 7)), R(_);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: se.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.prevYear, onClick: () => g((F) => F - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: se.title, "aria-live": "polite" }, i.year(`${E}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.nextYear, onClick: () => g((F) => F + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), w === "month" ? /* @__PURE__ */ n.createElement("div", { className: se.months, onKeyDown: (F) => {
    F.key === "Escape" && (F.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (F, L) => {
    const ae = Ba(E, L + 1), te = ae === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ae,
        type: "button",
        className: [se.mon, te ? se.sel : "", ae === _.slice(0, 7) ? se.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ae), x("day");
        }
      },
      i.m(`${ae}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: se.grid, role: "grid", "aria-label": i.ym(y), ref: B }, /* @__PURE__ */ n.createElement("div", { className: se.wdRow, role: "row" }, $.slice(0, 7).map((F) => {
    const L = Re(de(F));
    return /* @__PURE__ */ n.createElement("span", { key: F, role: "columnheader", className: L === 0 ? se.sun : L === 6 ? se.sat : "" }, i.weekdays[L]);
  })), [0, 1, 2, 3, 4, 5].map((F) => /* @__PURE__ */ n.createElement("div", { key: F, className: se.row, role: "row" }, $.slice(F * 7, F * 7 + 7).map((L) => {
    var Y;
    const ae = Re(de(L)), te = l[L], v = (Y = o[L]) != null ? Y : 0, I = [
      se.day,
      h(L) ? "" : se.out,
      ae === 0 || te ? se.sun : ae === 6 ? se.sat : "",
      L === _ ? se.isToday : "",
      L === a ? se.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L,
        type: "button",
        role: "gridcell",
        "data-day": L,
        className: I,
        tabIndex: L === N ? 0 : -1,
        "aria-selected": L === a,
        "aria-current": L === _ ? "date" : void 0,
        "aria-label": [i.dayAria(L), te, v ? k(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Z) => P(Z, L),
        onFocus: () => D(L),
        onClick: () => r(L)
      },
      /* @__PURE__ */ n.createElement("span", { className: se.num }, +L.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: se.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Z, A) => /* @__PURE__ */ n.createElement("i", { key: A })))
    );
  })))), u);
}
function Ld(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function xr(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function Dr(e, t = !0) {
  e = xr(e);
  const a = t && /^\s*-/.test(e), r = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return r ? (a ? "-" : "") + r.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function qd(e) {
  var r;
  if (e == null || e === "") return "";
  const t = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return a ? a[1] + Ld(a[2]) + ((r = a[3]) != null ? r : "") : t;
}
function Rd(e) {
  const t = Dr(e);
  if (t === "" || t === "-") return;
  const a = Number(t);
  return Number.isFinite(a) ? a : void 0;
}
function Id(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function m0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = q(null), i = q(null), [m, u] = S(!1), d = e == null || e === "";
  je(() => {
    const _ = c.current, y = i.current;
    if (i.current = null, !_ || y === null) return;
    let f = 0, b = 0;
    for (; f < _.value.length && b < y; )
      /\d/.test(_.value[f]) && (b += 1), f += 1;
    f === 0 && _.value[0] === "-" && (f = 1), _.setSelectionRange(f, f);
  });
  const p = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: m && d ? "-" : qd(e),
      onChange: (_) => {
        var b;
        const y = _.target;
        i.current = Id(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const f = Dr(y.value, a);
        if (r) {
          const $ = xr(y.value);
          !a && /^\s*-/.test($) ? r("sign") : (/\.\d/.test($.replace(/^\s*-/, "")) || /\.$/.test($)) && r("decimal");
        }
        u(f === "-"), t({ text: f, num: Rd(f) });
      }
    }
  );
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, p, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o)) : p;
}
const Od = "_box_qzg36_3", Pd = "_banner_qzg36_9", Xd = "_verify_qzg36_10", zd = "_t_info_qzg36_15", Fd = "_t_warn_qzg36_16", Wd = "_t_danger_qzg36_17", Hd = "_error_qzg36_22", Kd = "_note_qzg36_30", Ud = "_noteI_qzg36_42", Yd = "_noteBody_qzg36_43", Gd = "_badge_qzg36_49", Vd = "_b_muted_qzg36_53", Jd = "_b_ok_qzg36_54", Qd = "_b_warn_qzg36_55", Zd = "_b_info_qzg36_56", ef = "_b_off_qzg36_57", We = {
  box: Od,
  banner: Pd,
  verify: Xd,
  t_info: zd,
  t_warn: Fd,
  t_danger: Wd,
  error: Hd,
  note: Kd,
  noteI: Ud,
  noteBody: Yd,
  badge: Gd,
  b_muted: Vd,
  b_ok: Jd,
  b_warn: Qd,
  b_info: Zd,
  b_off: ef
};
function d0({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.banner, We[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function f0({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.verify, We[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Ar({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [We.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(tf, { text: t }) : t);
}
function _0({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [We.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: We.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: We.noteBody }, a));
}
function p0({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", We.badge, We[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function tf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(Hr, { key: a }, t))) : null;
}
const nf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function af(e, t = nf) {
  const a = q(e);
  return a.current = e, G(() => {
    if (!e) return;
    const r = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), le(() => !a.current || window.confirm(t), [t]);
}
const rf = "_overlay_1qt6w_2", of = "_modal_1qt6w_8", sf = "_wide_1qt6w_15", lf = "_head_1qt6w_16", cf = "_title_1qt6w_20", uf = "_close_1qt6w_21", mf = "_body_1qt6w_25", df = "_flush_1qt6w_26", ff = "_error_1qt6w_27", _f = "_foot_1qt6w_29", Ve = {
  overlay: rf,
  modal: of,
  wide: sf,
  head: lf,
  title: cf,
  close: uf,
  body: mf,
  flush: df,
  error: ff,
  foot: _f
}, Ct = [];
function ja(e) {
  const t = Ct[Ct.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const pf = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function La(e) {
  return Array.from(e.querySelectorAll(pf)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let qa = 0, Ra = "";
function ia({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [d, p] = S(!1), _ = u ? () => {
    d || p(!0);
  } : void 0, y = af(u && d, "입력한 내용을 저장하지 않고 닫을까요?"), f = () => {
    y() && t();
  }, b = q(f);
  b.current = f;
  const $ = q({ close: () => b.current(), esc: i });
  $.current.esc = i, G(() => {
    const g = $.current;
    return Ct.push(g), Ct.length === 1 && window.addEventListener("keydown", ja), () => {
      const h = Ct.lastIndexOf(g);
      h >= 0 && Ct.splice(h, 1), Ct.length === 0 && window.removeEventListener("keydown", ja);
    };
  }, []);
  const k = q(null), w = q(null), x = q(void 0);
  x.current === void 0 && (x.current = typeof document == "undefined" ? null : document.activeElement), G(() => {
    var N;
    const g = k.current, h = (N = x.current) != null ? N : null;
    return g && !g.contains(document.activeElement) && (w.current && La(w.current)[0] || null || g).focus(), qa++ === 0 && (Ra = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --qa === 0 && (document.body.style.overflow = Ra), h && h.isConnected && typeof h.focus == "function" && h.focus();
    };
  }, []);
  const E = (g) => {
    const h = k.current;
    if (g.key !== "Tab" || !h || !h.contains(g.target)) return;
    const N = La(h);
    if (N.length === 0) {
      g.preventDefault(), h.focus();
      return;
    }
    const D = N[0], j = N[N.length - 1], B = document.activeElement;
    g.shiftKey && (B === D || B === h) ? (g.preventDefault(), j.focus()) : !g.shiftKey && B === j && (g.preventDefault(), D.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ve.overlay, onClick: c ? f : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: k,
      tabIndex: -1,
      className: [Ve.modal, r ? Ve.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (g) => g.stopPropagation(),
      onKeyDown: E
    },
    /* @__PURE__ */ n.createElement("header", { className: Ve.head }, /* @__PURE__ */ n.createElement("strong", { className: Ve.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.close, onClick: f, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: w,
        className: [Ve.body, l ? Ve.flush : ""].filter(Boolean).join(" "),
        onInputCapture: _,
        onChangeCapture: _
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Ve.error }, /* @__PURE__ */ n.createElement(Ar, null, m)),
    o && /* @__PURE__ */ n.createElement("footer", { className: Ve.foot }, o)
  ));
}
function y0(e = 4e3) {
  const [t, a] = S(""), [r, o] = S(!1), s = q(void 0), l = le((m) => {
    window.clearTimeout(s.current), o(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = le((m) => {
    window.clearTimeout(s.current), o(!0), a(m);
  }, []), i = le(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const yf = "_message_psco6_1", bf = "_details_psco6_2", hf = "_warn_psco6_7", gf = "_field_psco6_8", fn = {
  message: yf,
  details: bf,
  warn: hf,
  field: gf
};
function b0() {
  var _, y;
  const [e, t] = S(null), [a, r] = S(""), o = q(null), s = q(null), l = q(null), c = le((f) => new Promise((b) => {
    t({ kind: "confirm", opts: f, resolve: b });
  }), []), i = le((f) => new Promise((b) => {
    var $, k, w, x;
    r((x = (w = f.defaultValue) != null ? w : (k = ($ = f.choices) == null ? void 0 : $[0]) == null ? void 0 : k.value) != null ? x : ""), t({ kind: "prompt", opts: f, resolve: b });
  }), []);
  G(() => {
    var f, b, $;
    e && (e.kind === "prompt" ? (f = l.current) == null || f.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : ($ = o.current) == null || $.focus());
  }, [e]);
  const m = (f) => {
    e && (e.kind === "confirm" ? e.resolve(f) : e.resolve(f ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, d = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), p = e && u ? /* @__PURE__ */ n.createElement(
    ia,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ft, { ref: s, onClick: () => m(!1) }, (_ = u.cancelLabel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(
        Ft,
        {
          ref: o,
          variant: u.danger ? "danger" : "primary",
          disabled: d,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: fn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: fn.details }, u.details.map((f, b) => /* @__PURE__ */ n.createElement("li", { key: b }, f))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: fn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: fn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (f) => r(f.target.value) }, e.opts.choices.map((f) => /* @__PURE__ */ n.createElement("option", { key: f.value, value: f.value }, f.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (f) => r(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && !d && (f.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: p };
}
function h0(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + Ef(e);
}
function Ef(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const vf = "_section_dyrr7_3", kf = "_row_dyrr7_10", wf = "_label_dyrr7_15", Nf = "_value_dyrr7_21", $f = "_invalid_dyrr7_43", xf = "_help_dyrr7_45", Df = "_err_dyrr7_45", Af = "_req_dyrr7_49", Cf = "_opt_dyrr7_50", Sf = "_sr_dyrr7_51", Mf = "_ro_dyrr7_10", Tf = "_readonly_dyrr7_58", Bf = "_hint_dyrr7_65", jf = "_toggle_dyrr7_73", Lf = "_table_dyrr7_80", qf = "_isReq_dyrr7_95", Ce = {
  section: vf,
  row: kf,
  label: wf,
  value: Nf,
  invalid: $f,
  help: xf,
  err: Df,
  req: Af,
  opt: Cf,
  sr: Sf,
  ro: Mf,
  readonly: Tf,
  hint: Bf,
  toggle: jf,
  table: Lf,
  isReq: qf
};
let Rf = 0;
const If = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function g0({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var E, g, h, N;
  const u = q(`axe-fr${++Rf}`).current, d = `${u}-lbl`, p = q(null), _ = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, f = [_, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let $ = t;
  const k = Kn.count(t) === 1 ? Kn.toArray(t)[0] : null, w = sn(k) && typeof k.type != "string" && !!k.type.axeFormControl;
  if (sn(k) && (typeof k.type == "string" && If.has(k.type) || w)) {
    const D = k, j = D.props;
    $ = na(D, {
      id: (E = j.id) != null ? E : o,
      "aria-describedby": (g = j["aria-describedby"]) != null ? g : f,
      "aria-invalid": (h = j["aria-invalid"]) != null ? h : i ? !0 : void 0,
      "aria-required": (N = j["aria-required"]) != null ? N : s ? !0 : void 0
    });
  }
  je(() => {
    var R;
    const D = (R = p.current) == null ? void 0 : R.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!D) return;
    const j = (T, P) => {
      const ee = `data-fr-${T}`;
      if (P == null) {
        D.hasAttribute(ee) && (D.removeAttribute(T), D.removeAttribute(ee));
        return;
      }
      D.hasAttribute(T) && !D.hasAttribute(ee) || (D.getAttribute(T) !== P && D.setAttribute(T, P), D.setAttribute(ee, ""));
    }, B = !!(D.id && document.querySelector(`label[for="${CSS.escape(D.id)}"]`));
    j("aria-labelledby", B ? null : d), j("aria-invalid", i ? "true" : null), j("aria-required", s ? "true" : null), j("aria-describedby", f != null ? f : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", s ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: d }, x) : /* @__PURE__ */ n.createElement("span", { id: d }, x), a && /* @__PURE__ */ n.createElement(Bt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: p, className: `axe-form-value ${Ce.value}` }, $, c && /* @__PURE__ */ n.createElement("span", { id: _, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function E0({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function v0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function k0({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const Of = "_mono_6omzf_2", Pf = "_invalid_6omzf_3", Xf = "_qty_6omzf_6", zf = "_qtyInput_6omzf_7", Ff = "_unit_6omzf_8", Wf = "_note_6omzf_9", Hf = "_qtyErr_6omzf_10", ht = {
  mono: Of,
  invalid: Pf,
  qty: Xf,
  qtyInput: zf,
  unit: Ff,
  note: Wf,
  qtyErr: Hf
};
function Kf({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": d,
  "aria-invalid": p,
  "aria-required": _,
  className: y = ""
}) {
  const f = [s ? ht.mono : "", l ? ht.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: f,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": m,
    "aria-describedby": d,
    "aria-invalid": p != null ? p : l || void 0,
    "aria-required": _,
    onChange: ($) => t($.target.value === "" ? null : $.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
Kf.axeFormControl = !0;
function Uf(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u
  } = e, d = (_) => {
    e.codeType === "string" ? e.onChange(_ === "" ? null : _) : e.onChange(_ === "" ? null : Number(_));
  }, p = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      value: t == null ? "" : String(t),
      disabled: o,
      "aria-label": s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (_) => d(_.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    p.map(([_, y]) => /* @__PURE__ */ n.createElement("option", { key: _, value: String(_) }, y))
  );
}
Uf.axeFormControl = !0;
function Yf(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const Gf = /^-?(\d+\.?\d*|\.\d+)$/;
function Qt(e) {
  const t = Yf(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!Gf.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Nn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Cr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Nn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, Nn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function It(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function Vf(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function Jf(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Cr(e + a * t, Math.max(r, Nn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const Qf = 2500;
function Zf({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": d,
  "aria-required": p,
  width: _,
  onEnter: y,
  onInvalidChange: f,
  placeholder: b,
  className: $ = ""
}) {
  const [k, w] = S(() => It(e)), [x, E] = S(!1), [g, h] = S(null), [N, D] = S(!1), j = q(null), B = q(k);
  B.current = k, G(() => {
    const v = Qt(B.current), I = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    I !== void 0 && I === (e != null ? e : null) || w(It(e));
  }, [e]), G(() => () => {
    j.current && clearTimeout(j.current);
  }, []);
  const R = Qt(k), T = R.kind === "bad" || R.kind === "partial";
  G(() => {
    T || D(!1);
  }, [T]);
  const P = q(f);
  P.current = f, G(() => {
    var v;
    (v = P.current) == null || v.call(P, T);
  }, [T]), G(() => () => {
    var v;
    (v = P.current) == null || v.call(P, !1);
  }, []);
  const ee = (v) => {
    j.current && clearTimeout(j.current), h(v), j.current = setTimeout(() => h(null), Qf);
  }, F = (v) => {
    w(v);
    const I = Qt(v);
    I.kind === "empty" ? t(null) : I.kind === "num" && t(I.value);
  }, L = () => {
    const v = Qt(k);
    if (v.kind !== "num") return;
    if (Nn(v.value) > a) {
      const Y = Cr(v.value, a);
      w(It(Y)), t(Y), ee(`반올림했습니다 → ${It(Y)}`);
      return;
    }
    const I = It(v.value);
    I !== k && w(I);
  }, ae = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (T) {
          D(!0);
          return;
        }
        L(), y == null || y();
        return;
      }
      if (s && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const I = Qt(k), Y = I.kind === "num" ? I.value : I.kind === "empty" ? null : e, Z = Jf(Y, s, v.key === "ArrowUp" ? 1 : -1, a, r, o);
        w(It(Z)), t(Z);
      }
    }
  }, te = R.kind === "bad" || R.kind === "partial" && (!x || N) || R.kind === "num" && Vf(R.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [ht.qty, $].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [ht.qtyInput, te ? ht.invalid : ""].filter(Boolean).join(" "),
      style: _ != null ? { width: _, maxWidth: "none" } : void 0,
      value: k,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": d != null ? d : te || void 0,
      "aria-required": p,
      onChange: (v) => F(v.target.value),
      onFocus: () => E(!0),
      onBlur: () => {
        E(!1), L();
      },
      onKeyDown: ae
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: ht.unit }, l), (R.kind === "bad" || R.kind === "partial" && (!x || N)) && /* @__PURE__ */ n.createElement("span", { className: ht.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: ht.note, role: "status", "aria-live": "polite" }, g));
}
Zf.axeFormControl = !0;
function e_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function t_(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    e_(e[s], t[s]) || r.push(s);
  }), r;
}
function n_(e, t) {
  return e === null || t === null ? e === t : t_(e, t).length === 0;
}
function w0() {
  const [e, t] = S(null), [a, r] = S(!1), [o, s] = S(null), l = we(() => a || !n_(o, e), [a, o, e]), c = le((_) => {
    t((y) => y === null ? y : { ...y, ..._ });
  }, []), i = le((_, y) => {
    t((f) => f === null ? f : { ...f, [_]: y });
  }, []), m = q(null), u = le((_) => {
    m.current = _, t(_), s(_), r(!1);
  }, []), d = le((_) => {
    m.current = _, t(_), s(_), r(!0);
  }, []), p = le(() => t(m.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: d, reset: p, snapshot: o }),
    [e, a, l, i, c, u, d, p, o]
  );
}
function N0() {
  const e = q(!1), [t, a] = S(!1), r = le(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const a_ = "_panel_1w7xx_2", r_ = "_band_1w7xx_7", o_ = "_chev_1w7xx_11", s_ = "_title_1w7xx_17", l_ = "_note_1w7xx_19", c_ = "_chip_1w7xx_21", i_ = "_other_1w7xx_32", u_ = "_reset_1w7xx_33", m_ = "_form_1w7xx_42", ot = {
  panel: a_,
  band: r_,
  chev: o_,
  title: s_,
  note: l_,
  chip: c_,
  other: i_,
  reset: u_,
  form: m_
};
function $0({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const d = q(null);
  if (i && !a && e.length === 0) return null;
  const p = (y, f = 0) => {
    var x, E, g;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : d.current, $ = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), k = (g = $ && ((E = $[y]) != null ? E : $[y - 1])) != null ? g : b == null ? void 0 : b.querySelector("button[aria-expanded]"), w = !document.activeElement || document.activeElement === document.body;
    k && k !== document.activeElement && (f === 0 || w) && k.focus(), f < 4 && setTimeout(() => p(y, f + 1), 250);
  }, _ = (y) => {
    e[y].onClear(), requestAnimationFrame(() => p(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [ot.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: ot.band, ref: d }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: ot.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, f) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [ot.chip, y.tone === "other" ? ot.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => _(f)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.reset, onClick: () => {
    t(), requestAnimationFrame(() => p(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: ot.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: ot.form }, c));
}
const d_ = "_zone_1y6sp_2", f_ = "_drag_1y6sp_8", __ = "_busy_1y6sp_9", p_ = "_attached_1y6sp_10", y_ = "_left_1y6sp_12", b_ = "_icon_1y6sp_13", h_ = "_title_1y6sp_18", g_ = "_desc_1y6sp_19", E_ = "_right_1y6sp_20", v_ = "_count_1y6sp_21", k_ = "_pick_1y6sp_22", Ke = {
  zone: d_,
  drag: f_,
  busy: __,
  attached: p_,
  left: y_,
  icon: b_,
  title: h_,
  desc: g_,
  right: E_,
  count: v_,
  pick: k_
};
function x0({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = q(null), [d, p] = S(!1), _ = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Ke.zone, d ? Ke.drag : "", l ? Ke.busy : "", c ? Ke.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || p(!0);
      },
      onDragLeave: () => p(!1),
      onDrop: (y) => {
        y.preventDefault(), p(!1), _(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: Ke.left }, /* @__PURE__ */ n.createElement("div", { className: Ke.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: Ke.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: Ke.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: Ke.right }, r && /* @__PURE__ */ n.createElement("span", { className: Ke.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Ke.pick,
        disabled: l,
        onClick: (y) => {
          var f;
          y.stopPropagation(), (f = u.current) == null || f.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          _(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function w_(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Sr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function D0(e, t, a) {
  Sr(await e.blob(), a != null ? a : w_(e, t));
}
const N_ = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, $_ = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Mr(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = $_.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = N_.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function zt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function x_(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => pn(zt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (l) => {
    var i;
    const c = D_(l, e);
    !c || c === o || (o = c, a.length > r && a.push(""), a.push(pn(zt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var _;
    if (l.tagName !== "TABLE") {
      if ((_ = l.parentElement) != null && _.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = A_(l, t);
      if (!y) return;
      s(l), a.push(y.map(pn).join(","));
      return;
    }
    const c = l;
    s(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, d = u >= 0 && !!c.querySelector("[data-csv-path]"), p = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const f = [];
      let b = 0;
      const $ = () => {
        for (; p[b] && p[b].n > 0; )
          p[b].n -= 1, p[b].skip || f.push(""), b += 1;
      };
      Array.from(y.cells).forEach((k) => {
        var h, N;
        $();
        const w = S_(k), x = w ? "" : M_(k, t), E = Math.max(1, k.colSpan || 1), g = Math.max(1, k.rowSpan || 1);
        for (let D = 0; D < E; D += 1)
          w || f.push(D === 0 ? x : ""), p[b] = { n: g - 1, skip: w }, b += 1;
        if (u >= 0 && k.cellIndex === u) {
          const D = k.querySelector("[data-tree-depth]");
          D ? (f.push(String(Number(D.getAttribute("data-tree-depth")) + 1)), d && f.push(zt((h = D.getAttribute("data-csv-path")) != null ? h : ""))) : ((N = y.parentElement) == null ? void 0 : N.tagName) === "THEAD" ? (f.push("단계"), d && f.push("상위 경로")) : (f.push(""), d && f.push(""));
        }
      }), $(), f.some((k) => k !== "") && a.push(f.map(pn).join(","));
    });
  }), a.join(`\r
`);
}
function D_(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function A_(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? _n(o) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? _n(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const d = r.cloneNode(!0);
    d.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = _n(d);
  } else {
    const d = e.cloneNode(!0);
    d.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = _n(d);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [zt(c), (u = Mr(i, t)) != null ? u : zt(i)];
}
function _n(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function C_(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Sr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function S_(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function M_(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Mr(r, t)) != null ? l : zt(r);
}
function pn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const T_ = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function A0({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Un,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await T_());
        try {
          const i = e.current;
          if (!i) return;
          C_(x_(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(hn, { name: "download", size: 14 }),
    "CSV"
  );
}
const B_ = "_card_1adld_1", j_ = "_sub_1adld_2", L_ = "_state_1adld_3", q_ = "_list_1adld_7", R_ = "_row_1adld_8", I_ = "_warn_1adld_20", O_ = "_danger_1adld_21", wt = {
  card: B_,
  sub: j_,
  state: L_,
  list: q_,
  row: R_,
  warn: I_,
  danger: O_
};
function C0({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    fr,
    {
      flush: !0,
      className: [wt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: wt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: wt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: wt.state }, /* @__PURE__ */ n.createElement(Ar, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(aa, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: wt.list }, c.map((m, u) => {
      var _, y;
      const d = [wt.row, m.tone ? wt[m.tone] : ""].filter(Boolean).join(" "), p = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (_ = m.key) != null ? _ : u, className: d, onClick: m.onClick }, p) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: d }, p);
    }))
  );
}
function P_(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const X_ = "_group_16rha_1", z_ = "_tile_16rha_2", F_ = "_click_16rha_9", W_ = "_ok_16rha_12", H_ = "_warn_16rha_13", K_ = "_danger_16rha_14", U_ = "_info_16rha_15", Y_ = "_accent_16rha_16", G_ = "_muted_16rha_17", V_ = "_label_16rha_18", J_ = "_value_16rha_20", Q_ = "_desc_16rha_25", $t = {
  group: X_,
  tile: z_,
  click: F_,
  ok: W_,
  warn: H_,
  danger: K_,
  info: U_,
  accent: Y_,
  muted: G_,
  label: V_,
  value: J_,
  desc: Q_
};
function S0({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  className: l = ""
}) {
  const c = [$t.tile, $t[o], s ? $t.click : "", l].filter(Boolean).join(" "), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: $t.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: $t.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: $t.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: c, onClick: s, "data-csv-kv": "" }, i) : /* @__PURE__ */ n.createElement("div", { className: c, "data-csv-kv": "" }, i);
}
const Z_ = 150, ep = 12, tp = 8;
function M0({ children: e, columns: t, className: a = "" }) {
  const r = q(null), o = Kn.toArray(e).filter(sn).length, s = t != null || o <= tp, [l, c] = S(null);
  je(() => {
    const u = r.current;
    if (!s || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const d = new ResizeObserver(() => c(u.clientWidth));
    return d.observe(u), () => d.disconnect();
  }, [s]);
  const i = s ? P_(o, l != null ? l : Number.MAX_SAFE_INTEGER, Z_, ep, t) : 0, m = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [$t.group, a].filter(Boolean).join(" "), style: m }, e);
}
const np = "_card_1lav2_1", ap = "_n_1lav2_2", rp = "_list_1lav2_7", op = "_row_1lav2_8", sp = "_go_1lav2_15", lp = "_name_1lav2_16", cp = "_empty_1lav2_17", ip = "_star_1lav2_18", up = "_clear_1lav2_27", Je = {
  card: np,
  n: ap,
  list: rp,
  row: op,
  go: sp,
  name: lp,
  empty: cp,
  star: ip,
  clear: up
};
function T0({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: o = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: s = ""
}) {
  const [l, c] = S("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    fr,
    {
      flush: !0,
      className: [Je.card, s].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        or,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => c(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Je.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(aa, { className: Je.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Je.list }, i.map((m) => /* @__PURE__ */ n.createElement("li", { key: m.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.row, onClick: () => a(m) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Je.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Je.name }, m.label))))) : /* @__PURE__ */ n.createElement("div", { className: Je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? o : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Ia(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Xn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function B0({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = S(() => Ia(e)), [s, l] = S(() => Ia(t)), c = le((d) => r.some((p) => p.path === d), [r]), i = le((d) => o((p) => {
    const _ = p.some((y) => y.path === d.path) ? p.filter((y) => y.path !== d.path) : [...p, d];
    return Xn(e, _), _;
  }), [e]), m = le((d) => l((p) => {
    const _ = [d, ...p.filter((y) => y.path !== d.path)].slice(0, a);
    return Xn(t, _), _;
  }), [t, a]), u = le(() => {
    l([]), Xn(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const mp = "_banner_7tqhk_2", dp = "_heading_7tqhk_7", fp = "_sparkleBox_7tqhk_8", _p = "_eyebrow_7tqhk_12", pp = "_headline_7tqhk_13", yp = "_desc_7tqhk_15", bp = "_err_7tqhk_16", hp = "_chips_7tqhk_18", gp = "_footer_7tqhk_28", Ep = "_kicker_7tqhk_35", vp = "_list_7tqhk_36", kp = "_row_7tqhk_37", wp = "_icon_7tqhk_39", Np = "_text_7tqhk_40", $p = "_cap_7tqhk_41", xp = "_body_7tqhk_43", Dp = "_reason_7tqhk_44", Ap = "_empty_7tqhk_45", be = {
  banner: mp,
  heading: dp,
  sparkleBox: fp,
  eyebrow: _p,
  headline: pp,
  desc: yp,
  err: bp,
  chips: hp,
  footer: gp,
  kicker: Ep,
  list: vp,
  row: kp,
  icon: wp,
  text: Np,
  cap: $p,
  body: xp,
  reason: Dp,
  empty: Ap
};
function Oa({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function j0({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: d = ""
}) {
  const p = o.slice(0, s), _ = o.length - p.length;
  return /* @__PURE__ */ n.createElement("section", { className: [be.banner, d].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: be.heading }, /* @__PURE__ */ n.createElement("span", { className: be.sparkleBox }, /* @__PURE__ */ n.createElement(Oa, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: be.eyebrow }, /* @__PURE__ */ n.createElement(Oa, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: be.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [be.desc, r ? be.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: be.chips }, p.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), _ > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", _, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: be.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? be.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(aa, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Cp({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: be.empty }, o) : /* @__PURE__ */ n.createElement("ul", { className: be.list }, e.map((s) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: s.id, className: be.row }, /* @__PURE__ */ n.createElement("span", { className: be.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: be.text }, /* @__PURE__ */ n.createElement("div", { className: be.cap }, s.title, s.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ n.createElement("div", { className: be.body }, s.body), s.reason ? /* @__PURE__ */ n.createElement("div", { className: be.reason }, s.reason) : null), /* @__PURE__ */ n.createElement(Ft, { variant: "primary", disabled: r, onClick: () => t(s) }, (c = s.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(Ft, { disabled: r, onClick: () => a(s) }, "무시"));
  }));
}
function L0({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = q(!1), [c, i] = S(!1), [m, u] = S(""), d = async (p) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await p();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    ia,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: be.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(Ft, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Cp, { items: a, busy: c, onRun: (p) => d(() => o(p)), onSkip: (p) => d(() => s(p)) })
  );
}
const Sp = "_wrap_1wvdc_2", Mp = "_header_1wvdc_7", Tp = "_iconBox_1wvdc_8", Bp = "_headText_1wvdc_12", jp = "_eyebrow_1wvdc_13", Lp = "_headline_1wvdc_14", qp = "_headerExtra_1wvdc_16", Rp = "_grid_1wvdc_19", Ip = "_card_1wvdc_20", Op = "_badge_1wvdc_29", Pp = "_toneRed_1wvdc_33", Xp = "_toneViolet_1wvdc_34", zp = "_toneGreen_1wvdc_35", Fp = "_toneBlue_1wvdc_36", Wp = "_title_1wvdc_38", Hp = "_summary_1wvdc_42", Kp = "_action_1wvdc_46", Up = "_notice_1wvdc_53", Yp = "_err_1wvdc_56", _e = {
  wrap: Sp,
  header: Mp,
  iconBox: Tp,
  headText: Bp,
  eyebrow: jp,
  headline: Lp,
  headerExtra: qp,
  grid: Rp,
  card: Ip,
  badge: Op,
  toneRed: Pp,
  toneViolet: Xp,
  toneGreen: zp,
  toneBlue: Fp,
  title: Wp,
  summary: Hp,
  action: Kp,
  notice: Up,
  err: Yp
};
function Pa({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const Gp = {
  red: _e.toneRed,
  violet: _e.toneViolet,
  green: _e.toneGreen,
  blue: _e.toneBlue
};
function q0({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: o,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [_e.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: _e.header }, /* @__PURE__ */ n.createElement("span", { className: _e.iconBox }, /* @__PURE__ */ n.createElement(Pa, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: _e.headText }, /* @__PURE__ */ n.createElement("div", { className: _e.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: _e.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: _e.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: _e.notice + " " + _e.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: _e.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: _e.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: _e.grid }, e.map((m) => {
    var u, d;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: _e.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [_e.badge, Gp[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Pa, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: _e.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: _e.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: _e.action }, (d = m.actionLabel) != null ? d : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Vp = "_wrapper_wrch3_1", Jp = "_searchIcon_wrch3_18", Qp = "_input_wrch3_26", Zp = "_clearButton_wrch3_40", ey = "_hint_wrch3_60", Zt = {
  wrapper: Vp,
  searchIcon: Jp,
  input: Qp,
  clearButton: Zp,
  hint: ey
}, ty = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function ny({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Zt.wrapper }, /* @__PURE__ */ n.createElement("span", { className: Zt.searchIcon }, ty), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: Zt.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Zt.clearButton,
      onClick: s,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: Zt.hint }, r));
}
const ay = "_screen_1bsma_1", ry = "_shell_1bsma_8", oy = "_command_1bsma_10", sy = "_body_1bsma_20", ly = "_overview_1bsma_22", cy = "_areaHead_1bsma_25", Pt = {
  screen: ay,
  shell: ry,
  command: oy,
  body: sy,
  overview: ly,
  areaHead: cy
};
function R0({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [Pt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Pt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Pt.command }, /* @__PURE__ */ n.createElement(
    ny,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Pt.body }, a)));
}
function I0({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Pt.overview, t].filter(Boolean).join(" ") }, e);
}
function O0({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Pt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const iy = "_group_oodts_1", uy = "_grid_oodts_7", my = "_row_oodts_8", dy = "_item_oodts_9", fy = "_launch_oodts_14", _y = "_name_oodts_17", py = "_desc_oodts_18", yy = "_badge_oodts_19", by = "_disabled_oodts_23", hy = "_tab_oodts_25", gy = "_star_oodts_25", Ey = "_on_oodts_30", vy = "_empty_oodts_32", Ie = {
  group: iy,
  grid: uy,
  row: my,
  item: dy,
  launch: fy,
  name: _y,
  desc: py,
  badge: yy,
  disabled: by,
  tab: hy,
  star: gy,
  on: Ey,
  empty: vy
};
function ky() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function wy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function P0({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Ie.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Ie.grid }, t.map((o) => /* @__PURE__ */ n.createElement("div", { className: Ie.row, key: o.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Ie.item, o.disabled ? Ie.disabled : ""].filter(Boolean).join(" "),
      disabled: o.disabled,
      onClick: o.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Ie.launch }, /* @__PURE__ */ n.createElement(ky, null)),
    /* @__PURE__ */ n.createElement("span", { className: Ie.name }, o.label),
    o.desc && /* @__PURE__ */ n.createElement("span", { className: Ie.desc }, o.desc),
    o.badge != null && /* @__PURE__ */ n.createElement("em", { className: Ie.badge }, o.badge)
  ), o.onOpenNewTab && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Ie.tab,
      "aria-label": `${o.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: o.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(wy, null)
  ), o.onToggleStar && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Ie.star, o.starred ? Ie.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!o.starred,
      "aria-label": `${o.label} ${o.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: o.onToggleStar
    },
    o.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Ie.empty }, a)));
}
const Ny = "_strip_8zhai_2", $y = "_day_8zhai_9", xy = "_total_8zhai_10", Dy = "_sel_8zhai_31", Ay = "_today_8zhai_35", Cy = "_md_8zhai_35", Sy = "_off_8zhai_36", My = "_head_8zhai_45", Ty = "_wd_8zhai_46", By = "_sun_8zhai_47", jy = "_sat_8zhai_48", Ly = "_lock_8zhai_50", qy = "_value_8zhai_60", Ry = "_mark_8zhai_66", Iy = "_warn_8zhai_67", Oy = "_danger_8zhai_68", Py = "_info_8zhai_69", $e = {
  strip: Ny,
  day: $y,
  total: xy,
  sel: Dy,
  today: Ay,
  md: Cy,
  off: Sy,
  head: My,
  wd: Ty,
  sun: By,
  sat: jy,
  lock: Ly,
  value: qy,
  mark: Ry,
  warn: Iy,
  danger: Oy,
  info: Py
}, Xa = ["일", "월", "화", "수", "목", "금", "토"];
function Xy(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function X0({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = q([]), m = (p) => {
    var y;
    const _ = e.length;
    for (let f = 0; f < _; f++) {
      const b = (p + f + _) % _;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (p, _) => {
    p.key === "ArrowRight" ? (p.preventDefault(), m(_ + 1)) : p.key === "ArrowLeft" ? (p.preventDefault(), m(_ - 1)) : p.key === "Home" ? (p.preventDefault(), m(0)) : p.key === "End" && (p.preventDefault(), m(e.length - 1));
  }, d = Math.max(0, e.findIndex((p) => p.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${$e.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((p, _) => {
    var k, w, x, E;
    const { md: y, wd: f } = Xy(p.date), b = [
      $e.day,
      p.off ? $e.off : "",
      p.date === t ? $e.sel : "",
      p.date === a ? $e.today : "",
      f === 0 ? $e.sun : f === 6 ? $e.sat : ""
    ].filter(Boolean).join(" "), $ = [`${y}(${Xa[f]})`, p.offLabel, p.locked ? "잠김" : null, (k = p.mark) == null ? void 0 : k.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: p.date,
        ref: (g) => {
          i.current[_] = g;
        },
        type: "button",
        className: b,
        disabled: p.disabled,
        tabIndex: _ === d ? 0 : -1,
        "aria-pressed": p.date === t,
        "aria-label": $,
        title: $,
        onClick: () => r == null ? void 0 : r(p.date),
        onKeyDown: (g) => u(g, _)
      },
      /* @__PURE__ */ n.createElement("span", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.wd }, Xa[f]), /* @__PURE__ */ n.createElement("span", { className: $e.md }, y), p.locked && /* @__PURE__ */ n.createElement("span", { className: $e.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: $e.value }, p.value),
      /* @__PURE__ */ n.createElement("span", { className: `${$e.mark}${p.mark ? ` ${$e[p.mark.tone]}` : ""}` }, (E = (w = p.mark) == null ? void 0 : w.text) != null ? E : p.off && (x = p.offLabel) != null ? x : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: $e.total }, /* @__PURE__ */ n.createElement("span", { className: $e.wd }, s), /* @__PURE__ */ n.createElement("span", { className: $e.value }, o)));
}
const zy = "_stepper_1wbt2_1", Fy = "_nav_1wbt2_2", Wy = "_today_1wbt2_3", Hy = "_range_1wbt2_14", en = {
  stepper: zy,
  nav: Fy,
  today: Wy,
  range: Hy
};
function Ky(e) {
  const t = sa(e);
  return t === 0 ? 7 : t;
}
function Uy(e, t = 1) {
  const a = (Ky(e) - t + 7) % 7;
  return An(e, -a);
}
function zn(e, t) {
  return An(e, t);
}
function z0({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = zn(e, 6), c = Uy(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: en.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.nav,
      onClick: () => t(zn(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: en.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.nav,
      onClick: () => t(zn(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const Yy = "_wrap_1dtpy_1", Gy = "_svg_1dtpy_2", Vy = "_grid_1dtpy_3", Jy = "_axis_1dtpy_4", Qy = "_accent_1dtpy_5", Zy = "_muted_1dtpy_6", eb = "_ok_1dtpy_7", tb = "_warn_1dtpy_8", nb = "_danger_1dtpy_9", ab = "_legend_1dtpy_10", rb = "_dot_accent_1dtpy_13", ob = "_dot_muted_1dtpy_14", sb = "_dot_ok_1dtpy_15", lb = "_dot_warn_1dtpy_16", cb = "_dot_danger_1dtpy_17", yt = {
  wrap: Yy,
  svg: Gy,
  grid: Vy,
  axis: Jy,
  accent: Qy,
  muted: Zy,
  ok: eb,
  warn: tb,
  danger: nb,
  legend: ab,
  dot_accent: rb,
  dot_muted: ob,
  dot_ok: sb,
  dot_warn: lb,
  dot_danger: cb
}, ib = 600;
function ub(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const za = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function F0({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = q(null), [c, i] = S(ib);
  je(() => {
    const h = l.current;
    if (!h) return;
    const N = () => {
      const j = h.clientWidth;
      j > 0 && i((B) => B === j ? B : j);
    };
    if (N(), typeof ResizeObserver == "undefined") return;
    const D = new ResizeObserver(N);
    return D.observe(h), () => D.disconnect();
  }, []);
  const m = r, u = 40, d = 22, p = 8, _ = c - u - 4, y = m - d - p, f = t.flatMap((h) => h.values.filter((N) => N != null)), b = ub(Math.max(0, ...f)), $ = Math.max(e.length, 1), k = _ / $, w = Math.min(8, k * 0.2), x = Math.max(1, (k - w) / Math.max(t.length, 1)), E = s != null ? s : Math.max(1, Math.ceil($ / 8)), g = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: yt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: yt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    g.map((h) => {
      const N = p + y - h / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: h }, /* @__PURE__ */ n.createElement("line", { className: yt.grid, x1: u, x2: c - 4, y1: N, y2: N }), /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u - 4, y: N + 3, textAnchor: "end" }, za(h)));
    }),
    e.map((h, N) => /* @__PURE__ */ n.createElement("g", { key: h }, t.map((D, j) => {
      var T;
      const B = D.values[N];
      if (B == null || B <= 0) return null;
      const R = B / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: D.key,
          className: yt[(T = D.tone) != null ? T : "accent"],
          x: u + N * k + w / 2 + j * x,
          y: p + y - R,
          width: x,
          height: R
        },
        /* @__PURE__ */ n.createElement("title", null, `${h} · ${D.label} ${za(B)}${a}`)
      );
    }), N % E === 0 && /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u + N * k + k / 2, y: m - 6, textAnchor: "middle" }, h)))
  ), /* @__PURE__ */ n.createElement("ul", { className: yt.legend }, t.map((h) => {
    var N;
    return /* @__PURE__ */ n.createElement("li", { key: h.key }, /* @__PURE__ */ n.createElement("i", { className: yt[`dot_${(N = h.tone) != null ? N : "accent"}`], "aria-hidden": "true" }), h.label, a ? ` (${a})` : "");
  })));
}
const mb = "_wrap_85lir_1", db = "_track_85lir_2", fb = "_accent_85lir_3", _b = "_muted_85lir_3", pb = "_ok_85lir_3", yb = "_warn_85lir_3", bb = "_danger_85lir_3", hb = "_center_85lir_9", gb = "_legend_85lir_10", Eb = "_name_85lir_13", vb = "_val_85lir_14", kb = "_pct_85lir_15", wb = "_dot_accent_85lir_16", Nb = "_dot_muted_85lir_17", $b = "_dot_ok_85lir_18", xb = "_dot_warn_85lir_19", Db = "_dot_danger_85lir_20", st = {
  wrap: mb,
  track: db,
  accent: fb,
  muted: _b,
  ok: pb,
  warn: yb,
  danger: bb,
  center: hb,
  legend: gb,
  name: Eb,
  val: vb,
  pct: kb,
  dot_accent: wb,
  dot_muted: Nb,
  dot_ok: $b,
  dot_warn: xb,
  dot_danger: Db
}, Jn = 40, Fa = 2 * Math.PI * Jn;
function W0({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: st.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: st.track, cx: "50", cy: "50", r: Jn }), l > 0 && e.map((i) => {
    var d;
    const m = Math.max(0, i.value) / l * Fa, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: st[(d = i.tone) != null ? d : "accent"],
        cx: "50",
        cy: "50",
        r: Jn,
        strokeDasharray: `${m} ${Fa - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: st.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: st.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: st[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: st.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: st.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: st.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Ab = "_wrap_1b8ll_1", Cb = "_track_1b8ll_2", Sb = "_compact_1b8ll_3", Mb = "_fill_1b8ll_4", Tb = "_accent_1b8ll_5", Bb = "_muted_1b8ll_6", jb = "_ok_1b8ll_7", Lb = "_warn_1b8ll_8", qb = "_danger_1b8ll_9", Rb = "_num_1b8ll_10", Ib = "_none_1b8ll_12", Nt = {
  wrap: Ab,
  track: Cb,
  compact: Sb,
  fill: Mb,
  accent: Tb,
  muted: Bb,
  ok: jb,
  warn: Lb,
  danger: qb,
  num: Rb,
  none: Ib
};
function H0({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Nt.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Nt.wrap, r ? Nt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: Nt.track }, /* @__PURE__ */ n.createElement("span", { className: `${Nt.fill} ${Nt[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Nt.num }, o, "%")
  );
}
const Ob = { day: 28, week: 10, month: 3 };
function Mt(e, t) {
  return An(e, t);
}
function Qn(e, t) {
  return gt(t) - gt(e) + 1;
}
function Tr(e) {
  return sa(e);
}
const Wa = (e) => {
  const t = Tr(e);
  return t === 0 || t === 6;
};
function Ot(e, t, a, r) {
  const o = [], s = Qn(e, t);
  for (let l = 0; l < s; l++) {
    const c = Mt(e, l), i = a(c), m = o[o.length - 1];
    m && m.key === i ? m.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function Pb(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Ot(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Ot(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Mt(l, -((Tr(l) + 6) % 7));
    return {
      top: Ot(e, t, r, o),
      bottom: Ot(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Ot(e, t, r, o),
    bottom: Ot(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function Fn(e, t, a, r) {
  if (a === "move") return { start: Mt(e, r), end: Mt(t, r) };
  if (a === "start") {
    const s = Mt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Mt(t, r);
  return { start: e, end: o < e ? e : o };
}
const Xb = "_gantt_1smka_3", zb = "_scroll_1smka_15", Fb = "_canvas_1smka_21", Wb = "_head_1smka_24", Hb = "_headLabel_1smka_32", Kb = "_headTrack_1smka_43", Ub = "_band_1smka_44", Yb = "_seg_1smka_46", Gb = "_tick_1smka_59", Vb = "_tickOff_1smka_60", Jb = "_body_1smka_62", Qb = "_overlay_1smka_65", Zb = "_weekend_1smka_66", eh = "_holiday_1smka_66", th = "_today_1smka_68", nh = "_row_1smka_70", ah = "_label_1smka_76", rh = "_sel_1smka_77", oh = "_track_1smka_77", sh = "_dim_1smka_78", lh = "_labelText_1smka_95", ch = "_dot_1smka_96", ih = "_warn_1smka_97", uh = "_err_1smka_98", mh = "_bar_1smka_113", dh = "_can_1smka_21", fh = "_dragging_1smka_126", _h = "_fill_1smka_127", ph = "_late_1smka_128", yh = "_summary_1smka_130", bh = "_handle_1smka_133", hh = "_hL_1smka_134", gh = "_hR_1smka_135", Eh = "_mark_1smka_137", vh = "_barText_1smka_138", kh = "_empty_1smka_147", wh = "_srOnly_1smka_150", ne = {
  gantt: Xb,
  scroll: zb,
  canvas: Fb,
  head: Wb,
  headLabel: Hb,
  headTrack: Kb,
  band: Ub,
  seg: Yb,
  tick: Gb,
  tickOff: Vb,
  body: Jb,
  overlay: Qb,
  weekend: Zb,
  holiday: eh,
  today: th,
  row: nh,
  label: ah,
  sel: rh,
  track: oh,
  dim: sh,
  labelText: lh,
  dot: ch,
  warn: ih,
  err: uh,
  bar: mh,
  can: dh,
  dragging: fh,
  fill: _h,
  late: ph,
  summary: yh,
  handle: bh,
  hL: hh,
  hR: gh,
  mark: Eh,
  barText: vh,
  empty: kh,
  srOnly: wh
}, Ha = 28, Ka = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let Nh = 0;
function K0({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: d,
  lockedReason: p,
  scrollMemory: _,
  className: y = "",
  style: f,
  "aria-label": b
}) {
  const $ = q("");
  $.current || ($.current = `axe-gantt-keys-${++Nh}`);
  const k = Ob[r], w = Math.max(Qn(t, a), 1), x = gt(t), E = w * k, g = we(() => Pb(t, a, r), [t, a, r]), h = we(() => {
    const v = [];
    for (let I = 0; I < w; I++) {
      const Y = Mt(t, I), Z = Y in o;
      if (!Z && !Wa(Y)) continue;
      const A = v[v.length - 1];
      A && A.offset + A.days === I && A.holiday === Z ? A.days++ : v.push({ offset: I, days: 1, holiday: Z });
    }
    return v;
  }, [t, w, o]), [N, D] = S(null), j = q(null), B = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, R = (v, I, Y) => {
    if (!B(I) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Z = { id: I.id, mode: Y, x: v.clientX, delta: 0, moved: !1 };
    j.current = Z, D(Z);
  }, T = (v) => {
    const I = j.current;
    if (!I) return;
    const Y = Math.round((v.clientX - I.x) / k), Z = I.moved || Math.abs(v.clientX - I.x) > 3;
    if (Y !== I.delta || Z !== I.moved) {
      const A = { ...I, delta: Y, moved: Z };
      j.current = A, D(A);
    }
  }, P = (v) => {
    const I = j.current;
    if (j.current = null, D(null), !!I) {
      if (!I.moved) {
        i == null || i(v);
        return;
      }
      I.delta !== 0 && v.start && v.end && (c == null || c(v, Fn(v.start, v.end, I.mode, I.delta), I.mode));
    }
  }, ee = () => {
    j.current = null, D(null);
  }, F = (v, I) => {
    if (v.key === "Escape" && j.current) {
      ee();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(I);
      return;
    }
    if (!B(I) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const Y = v.key === "ArrowLeft" ? -1 : 1, Z = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(I, Fn(I.start, I.end, Z, Y), Z);
  }, L = s ? gt(s) - x : -1, ae = q(null), te = q(null);
  return je(() => {
    const v = ae.current;
    if (v && (_ != null && _.current) && te.current === null) {
      te.current = r, v.scrollLeft = _.current.left, v.scrollTop = _.current.top;
      return;
    }
    if (!l || !v || L < 0 || L >= w || te.current === r) return;
    te.current = r;
    const I = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, L * k + k / 2 - I / 3);
  }, [l, r, L, w, k, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ne.gantt, y].filter(Boolean).join(" "),
      style: f,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && j.current && ee();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: $.current, className: ne.srOnly }, Ka),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ae,
        className: ne.scroll,
        onScroll: _ ? (v) => {
          _.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ne.canvas, style: { width: u + E } }, /* @__PURE__ */ n.createElement("div", { className: ne.head, style: { gridTemplateColumns: `${u}px ${E}px` } }, /* @__PURE__ */ n.createElement("div", { className: ne.headLabel }, d), /* @__PURE__ */ n.createElement("div", { className: ne.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ne.band }, g.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ne.seg, style: { left: v.offset * k, width: v.days * k }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ne.band }, g.bottom.map((v) => {
        var Y;
        const I = r === "day" && (v.key in o || Wa(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ne.seg, ne.tick, I ? ne.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * k, width: v.days * k },
            title: (Y = o[v.key]) != null ? Y : v.key
          },
          v.days * k >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ne.body, style: { minHeight: Ha } }, /* @__PURE__ */ n.createElement("div", { className: ne.overlay, style: { left: u, width: E }, "aria-hidden": "true" }, h.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ne.holiday : ne.weekend, style: { left: v.offset * k, width: v.days * k } })), L >= 0 && L < w && /* @__PURE__ */ n.createElement("span", { className: ne.today, style: { left: L * k + k / 2 }, title: "오늘" })), e.map((v) => {
        var K, Q, Ne, He;
        const I = !!v.start && !!v.end && v.start <= v.end, Y = N && N.id === v.id ? N : null, Z = I && Y && Y.delta !== 0 ? Fn(v.start, v.end, Y.mode, Y.delta) : I ? { start: v.start, end: v.end } : null, A = Z ? (gt(Z.start) - x) * k : 0, V = Z ? Qn(Z.start, Z.end) * k : 0, J = Math.max(0, Math.min(100, (K = v.progress) != null ? K : 0)), X = m != null && m === v.id, z = B(v), O = !z && c && Z ? p == null ? void 0 : p(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ne.row, X ? ne.sel : "", v.dim ? ne.dim : ""].filter(Boolean).join(" "),
            style: { height: Ha }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ne.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ne.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ne.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ne.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ne.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ne.track, style: { width: E }, onClick: () => !Y && (i == null ? void 0 : i(v)) }, Z ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ne.bar, v.summary ? ne.summary : "", v.late ? ne.late : "", z ? ne.can : "", Y ? ne.dragging : ""].filter(Boolean).join(" "),
              style: { left: A, width: Math.max(V, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(Q = v.name) != null ? Q : ""} ${Z.start} ~ ${Z.end}${v.progress != null ? ` ${J}%` : ""}${v.late ? " 지연" : ""}${O ? ` 잠김: ${O}` : ""}`,
              "aria-describedby": z ? $.current : void 0,
              title: `${Z.start} ~ ${Z.end}${v.progress != null ? ` · ${J}%` : ""}${v.late ? " · 지연" : ""}${z ? `
끌어 옮기기·양 끝 조절
${Ka}` : ""}${O ? `
잠김: ${O}` : ""}`,
              onPointerDown: (qe) => R(qe, v, "move"),
              onPointerMove: T,
              onPointerUp: () => P(v),
              onPointerCancel: ee,
              onClick: (qe) => qe.stopPropagation(),
              onKeyDown: (qe) => F(qe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ne.fill, style: { width: `${J}%` } }),
            z && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ne.handle} ${ne.hL}`, onPointerDown: (qe) => R(qe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ne.handle} ${ne.hR}`, onPointerDown: (qe) => R(qe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ne.mark, style: { left: (gt(v.markDate) - x + 1) * k - 1 }, title: (Ne = v.markLabel) != null ? Ne : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ne.barText, style: { left: A + Math.max(V, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ne.empty }, (He = v.emptyText) != null ? He : "기간 없음"))
        );
      })))
    )
  );
}
const $h = "_board_192fl_3", xh = "_col_192fl_15", Dh = "_over_192fl_23", Ah = "_head_192fl_25", Ch = "_title_192fl_33", Sh = "_count_192fl_34", Mh = "_hint_192fl_43", Th = "_list_192fl_45", Bh = "_empty_192fl_54", jh = "_card_192fl_56", Lh = "_sel_192fl_68", qh = "_dragging_192fl_69", Rh = "_hasErr_192fl_70", Ih = "_dot_192fl_71", Oh = "_err_192fl_72", Me = {
  board: $h,
  col: xh,
  over: Dh,
  head: Ah,
  title: Ch,
  count: Sh,
  hint: Mh,
  list: Th,
  empty: Bh,
  card: jh,
  sel: Lh,
  dragging: qh,
  hasErr: Rh,
  dot: Ih,
  err: Oh
}, Wn = "application/x-axerp-kanban";
function U0({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: d,
  emptyText: p = "카드가 없습니다",
  moveHint: _,
  className: y = "",
  style: f,
  "aria-label": b
}) {
  const $ = Yt("axe-kb"), [k, w] = S(null), [x, E] = S(null), g = new Map(t.map((B) => [String(a(B)), B])), h = q(null), N = q(null);
  G(() => {
    var T, P;
    const B = N.current;
    if (!B) return;
    if (Date.now() > B.until) {
      N.current = null;
      return;
    }
    const R = Array.from((P = (T = h.current) == null ? void 0 : T.querySelectorAll("[data-kanban-key]")) != null ? P : []).find((ee) => ee.dataset.kanbanKey === B.key);
    R && document.activeElement !== R && R.focus(), N.current = null;
  });
  const D = (B, R) => {
    B.preventDefault(), w(null), E(null);
    const T = B.dataTransfer.getData(Wn), P = g.get(T);
    P && r(P) !== R && (l == null || l(P, R));
  }, j = (B, R) => {
    if (B.key === "Enter" || B.key === " ") {
      B.preventDefault(), c == null || c(R);
      return;
    }
    if (!l || !B.altKey || B.key !== "ArrowLeft" && B.key !== "ArrowRight" || d != null && d(R)) return;
    B.preventDefault();
    const T = e.findIndex((ee) => ee.key === r(R)), P = T + (B.key === "ArrowLeft" ? -1 : 1);
    T >= 0 && P >= 0 && P < e.length && (N.current = { key: String(a(R)), until: Date.now() + 1500 }, l(R, e[P].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: h, className: [Me.board, y].filter(Boolean).join(" "), style: f, role: "region", "aria-label": b != null ? b : "보드" }, e.map((B) => {
    const R = t.filter((T) => r(T) === B.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: B.key,
        className: [Me.col, k === B.key ? Me.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof B.title == "string" ? B.title : void 0,
        onDragOver: l ? (T) => {
          T.dataTransfer.types.includes(Wn) && (T.preventDefault(), w(B.key));
        } : void 0,
        onDragLeave: l ? (T) => {
          T.currentTarget.contains(T.relatedTarget) || w((P) => P === B.key ? null : P);
        } : void 0,
        onDrop: l ? (T) => D(T, B.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.title }, B.title), /* @__PURE__ */ n.createElement("span", { className: Me.count }, R.length), B.hint && /* @__PURE__ */ n.createElement("span", { className: Me.hint }, B.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Me.list }, R.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Me.empty }, p), R.map((T) => {
        const P = a(T), ee = d == null ? void 0 : d(T), F = u == null ? void 0 : u(T), L = !!l && !ee, ae = ee != null ? ee : L ? _ != null ? _ : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: P,
            className: [Me.card, i === P ? Me.sel : "", x === P ? Me.dragging : "", F ? Me.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(P),
            role: "button",
            "aria-label": s == null ? void 0 : s(T),
            "aria-keyshortcuts": L ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ae,
            "aria-describedby": ae ? `${$}-h-${String(P)}` : void 0,
            draggable: L,
            onDragStart: L ? (te) => {
              te.dataTransfer.setData(Wn, String(P)), te.dataTransfer.effectAllowed = "move", E(P);
            } : void 0,
            onDragEnd: () => {
              E(null), w(null);
            },
            onClick: () => c == null ? void 0 : c(T),
            onKeyDown: (te) => j(te, T)
          },
          ae && /* @__PURE__ */ n.createElement(_r, { id: `${$}-h-${String(P)}` }, ae),
          (m == null ? void 0 : m(T)) && /* @__PURE__ */ n.createElement("span", { className: Me.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(T),
          F && /* @__PURE__ */ n.createElement("p", { className: Me.err, role: "alert" }, F)
        );
      }))
    );
  }));
}
const Ph = "_list_1aqum_2", Xh = "_empty_1aqum_3", zh = "_item_1aqum_5", Fh = "_row_block_1aqum_6", Wh = "_row_warn_1aqum_7", Hh = "_head_1aqum_9", Kh = "_mark_1aqum_16", Uh = "_msg_1aqum_17", Yh = "_count_1aqum_18", Gh = "_aside_1aqum_19", Vh = "_caret_1aqum_20", Jh = "_block_1aqum_22", Qh = "_warn_1aqum_23", Zh = "_info_1aqum_24", e1 = "_body_1aqum_29", t1 = "_actions_1aqum_30", Te = {
  list: Ph,
  empty: Xh,
  item: zh,
  row_block: Fh,
  row_warn: Wh,
  head: Hh,
  mark: Kh,
  msg: Uh,
  count: Yh,
  aside: Gh,
  caret: Vh,
  block: Jh,
  warn: Qh,
  info: Zh,
  body: e1,
  actions: t1
}, n1 = { block: "■", warn: "▲", info: "●" }, a1 = { block: "차단", warn: "경고", info: "정보" };
function Y0({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = S({}), [l, c] = S(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Te.list} ${r}` }, e.map((i) => {
    var p;
    const m = !!i.detail || !!i.actions, u = m && ((p = o[i.key]) != null ? p : a.includes(i.tone)), d = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Te.mark} ${Te[i.tone]}`, "aria-label": a1[i.tone], role: "img" }, n1[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Te.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Te.count} ${Te[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Te.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Te.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Te.item} ${Te[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Te.head,
        "aria-expanded": u,
        onClick: () => s((_) => ({ ..._, [i.key]: !u }))
      },
      d
    ) : /* @__PURE__ */ n.createElement("div", { className: Te.head }, d), u && /* @__PURE__ */ n.createElement("div", { className: Te.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Te.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Te.empty} ${r}` }, t);
}
function r1(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function o1(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function G0(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function V0(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const s1 = "_nav_1r2z8_1", l1 = "_list_1r2z8_3", c1 = "_btn_1r2z8_4", i1 = "_cur_1r2z8_13", u1 = "_gap_1r2z8_15", m1 = "_total_1r2z8_16", d1 = "_jump_1r2z8_17", f1 = "_go_1r2z8_20", _1 = "_size_1r2z8_22", p1 = "_more_1r2z8_24", y1 = "_moreBtn_1r2z8_25", b1 = "_moreN_1r2z8_29", Ee = {
  nav: s1,
  list: l1,
  btn: c1,
  cur: i1,
  gap: u1,
  total: m1,
  jump: d1,
  in: "_in_1r2z8_18",
  go: f1,
  size: _1,
  more: p1,
  moreBtn: y1,
  moreN: b1
};
function J0({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [d, p] = S(String(u));
  G(() => p(String(u)), [u]);
  const _ = (f) => {
    f !== u && f >= 1 && f <= m && a(f);
  }, y = () => {
    const f = o1(d, m);
    if (f === null) {
      p(String(u));
      return;
    }
    p(String(f)), _(f);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Ee.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: Ee.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: Ee.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => _(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => _(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), r1(u, m).map((f, b) => f === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: Ee.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: f }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Ee.btn, f === u ? Ee.cur : ""].filter(Boolean).join(" "),
      onClick: () => _(f),
      "aria-current": f === u ? "page" : void 0,
      "aria-label": `${f}쪽`
    },
    f
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => _(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => _(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: Ee.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: Ee.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: Ee.in,
      inputMode: "numeric",
      value: d,
      "aria-label": "이동할 쪽 번호",
      onChange: (f) => p(f.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (f) => {
        f.key === "Enter" && (f.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: Ee.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: s, onChange: (f) => l(Number(f.target.value)) }, o.map((f) => /* @__PURE__ */ n.createElement("option", { key: f, value: f }, f, "건")))));
}
function Q0({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [Ee.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: Ee.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const h1 = "_ol_fbatg_1", g1 = "_li_fbatg_2", E1 = "_done_fbatg_5", v1 = "_now_fbatg_5", k1 = "_item_fbatg_6", w1 = "_dot_fbatg_12", N1 = "_label_fbatg_19", $1 = "_opt_fbatg_21", x1 = "_sr_fbatg_22", lt = {
  ol: h1,
  li: g1,
  done: E1,
  now: v1,
  item: k1,
  dot: w1,
  label: N1,
  opt: $1,
  sr: x1
};
function Z0({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [lt.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: lt.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: lt.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: lt.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: lt.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [lt.li, lt[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: lt.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: lt.item }, c));
  }));
}
const D1 = "_root_7y5bc_5", A1 = "_block_7y5bc_6", C1 = "_svg_7y5bc_7", S1 = "_sm_7y5bc_8", M1 = "_md_7y5bc_9", T1 = "_lg_7y5bc_10", B1 = "_track_7y5bc_11", j1 = "_bar_7y5bc_12", L1 = "_spin_7y5bc_13", q1 = "_txt_7y5bc_15", bt = {
  root: D1,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: A1,
  svg: C1,
  sm: S1,
  md: M1,
  lg: T1,
  track: B1,
  bar: j1,
  spin: L1,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: q1,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function ev({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [bt.root, o ? bt.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [bt.svg, bt[e], l ? "" : bt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: bt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: bt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: bt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const R1 = "_group_xpsei_1", I1 = "_legend_xpsei_2", O1 = "_req_xpsei_3", P1 = "_opts_xpsei_4", X1 = "_inline_xpsei_5", z1 = "_all_xpsei_6", F1 = "_opt_xpsei_4", W1 = "_dis_xpsei_11", H1 = "_radio_xpsei_12", K1 = "_check_xpsei_12", U1 = "_text_xpsei_14", Y1 = "_hint_xpsei_15", G1 = "_err_xpsei_16", pe = {
  group: R1,
  legend: I1,
  req: O1,
  opts: P1,
  inline: X1,
  all: z1,
  opt: F1,
  dis: W1,
  radio: H1,
  check: K1,
  text: U1,
  hint: Y1,
  err: G1
};
function Br({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: pe.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: pe.req }, " (필수)"));
}
function tv({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: m = "" }) {
  const u = Yt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? u : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Br, { legend: t, required: s }),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, i ? pe.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((d) => /* @__PURE__ */ n.createElement("label", { key: d.value, className: [pe.opt, d.disabled ? pe.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: pe.radio,
        name: e,
        value: d.value,
        checked: r === d.value,
        disabled: d.disabled,
        required: s,
        onChange: () => o(d.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: pe.text }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, d.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, c)
  );
}
function Ua({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [pe.opt, r ? pe.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: pe.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: pe.text }, o));
}
function nv({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Yt("axe-cg-err"), d = t.filter((f) => !f.disabled).map((f) => f.value), p = d.length > 0 && d.every((f) => a.includes(f)), _ = d.some((f) => a.includes(f)), y = (f, b) => r(b ? [...a, f] : a.filter(($) => $ !== f));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Br, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: pe.all }, /* @__PURE__ */ n.createElement(
      Ua,
      {
        checked: p,
        indeterminate: _ && !p,
        onChange: (f) => r(f ? Array.from(/* @__PURE__ */ new Set([...a, ...d])) : a.filter((b) => !d.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, c ? pe.inline : ""].filter(Boolean).join(" ") }, t.map((f) => /* @__PURE__ */ n.createElement(Ua, { key: f.value, checked: a.includes(f.value), disabled: f.disabled, onChange: (b) => y(f.value, b) }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, f.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, l)
  );
}
const V1 = "_list_13vw7_1", J1 = "_tag_13vw7_2", Q1 = "_main_13vw7_3", Z1 = "_x_13vw7_6", eg = "_t_muted_13vw7_10", tg = "_t_accent_13vw7_11", ng = "_t_ok_13vw7_12", ag = "_t_warn_13vw7_13", rg = "_t_danger_13vw7_14", og = "_sel_13vw7_16", xt = {
  list: V1,
  tag: J1,
  main: Q1,
  x: Z1,
  t_muted: eg,
  t_accent: tg,
  t_ok: ng,
  t_warn: ag,
  t_danger: rg,
  sel: og
};
function av({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [xt.tag, xt[`t_${t}`], a ? xt.sel : "", c].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: xt.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: xt.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: xt.x, onClick: o, disabled: l, "aria-label": m }, "✕"));
}
function rv({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [xt.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const sg = "_acc_1lmty_1", lg = "_item_1lmty_2", cg = "_h_1lmty_3", ig = "_btn_1lmty_4", ug = "_title_1lmty_8", mg = "_meta_1lmty_9", dg = "_chev_1lmty_10", fg = "_open_1lmty_11", _g = "_body_1lmty_12", ct = {
  acc: sg,
  item: lg,
  h: cg,
  btn: ig,
  title: ug,
  meta: mg,
  chev: dg,
  open: fg,
  body: _g
};
function ov({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = S(a), m = r != null ? r : c, u = Yt("axe-acc"), d = `h${s}`, p = (_) => {
    const y = m.includes(_) ? m.filter((f) => f !== _) : t ? [_] : [...m, _];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ct.acc, l].filter(Boolean).join(" ") }, e.map((_) => {
    const y = m.includes(_.key), f = `${u}-b-${_.key}`, b = `${u}-p-${_.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: _.key, className: [ct.item, y ? ct.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(d, { className: ct.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: f,
        className: ct.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: _.disabled,
        onClick: () => p(_.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: ct.title }, _.title),
      _.meta && /* @__PURE__ */ n.createElement("span", { className: ct.meta }, _.meta),
      /* @__PURE__ */ n.createElement("span", { className: ct.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": f, hidden: !y, className: ct.body }, _.content));
  }));
}
const pg = "_stack_1u83j_2", yg = "_toast_1u83j_3", bg = "_t_danger_1u83j_9", hg = "_ico_1u83j_10", gg = "_t_ok_1u83j_11", Eg = "_msg_1u83j_12", vg = "_act_1u83j_13", kg = "_x_1u83j_15", Dt = {
  stack: pg,
  toast: yg,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: bg,
  ico: hg,
  t_ok: gg,
  msg: Eg,
  act: vg,
  x: kg
}, jr = Dn(null);
let wg = 0;
function sv() {
  const e = xn(jr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function Ng({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = S(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  G(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Dt.toast, Dt[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Dt.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Dt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function lv({ children: e }) {
  const [t, a] = S([]), r = q(t);
  r.current = t;
  const o = le((c) => a((i) => i.filter((m) => m.id !== c)), []), s = le((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((d) => d.message === i.message);
    if (m)
      return a((d) => d.map((p) => p.id === m.id ? { ...p, ...i } : p)), m.id;
    const u = ++wg;
    return a((d) => [...d, { ...i, id: u }].slice(-3)), u;
  }, []), l = we(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(jr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Dt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(Ng, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const $g = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function xg(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const Dg = "_grid_yplhe_1", Ag = "_group_yplhe_2", Cg = "_h_yplhe_3", Sg = "_list_yplhe_4", Mg = "_row_yplhe_5", Tg = "_keys_yplhe_6", Bg = "_text_yplhe_7", jg = "_or_yplhe_8", Lg = "_kbd_yplhe_9", it = {
  grid: Dg,
  group: Ag,
  h: Cg,
  list: Sg,
  row: Mg,
  keys: Tg,
  text: Bg,
  or: jg,
  kbd: Lg
};
function qg({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...$g];
  return /* @__PURE__ */ n.createElement(ia, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: it.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: it.group }, /* @__PURE__ */ n.createElement("h3", { className: it.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: it.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: it.row }, /* @__PURE__ */ n.createElement("dt", { className: it.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: it.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: it.text }, o.text))))))));
}
function Rg(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function cv(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = S(!1);
  return G(() => {
    if (!t) return;
    const s = (l) => {
      xg(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, Rg(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(qg, { extra: a, onClose: () => o(!1) }) : null };
}
const Ya = 30, Ig = BigInt(10);
function Kt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * Ig;
  return t;
}
function dt(e, t = 0) {
  return { u: e, s: t };
}
const Lr = dt(BigInt(0));
function qr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Kt(a - e.s), t.u * Kt(a - t.s), a];
}
function un(e, t) {
  const [a, r, o] = qr(e, t);
  return dt(a + r, o);
}
function ua(e, t) {
  const [a, r, o] = qr(e, t);
  return dt(a - r, o);
}
function tt(e, t) {
  return dt(e.u * t.u, e.s + t.s);
}
function Tt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Kt(t.s + Ya), r = t.u * Kt(e.s);
  return dt(a / r, Ya);
}
function Rr(e) {
  return dt(-e.u, e.s);
}
function ft(e, t, a) {
  if (t >= e.s)
    return dt(e.u * Kt(t - e.s), t);
  const r = Kt(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, dt(o ? -i : i, t);
}
function he(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return dt(a ? -c : c, l);
}
function ma(e) {
  var a;
  const t = he(String(e));
  return t || ((a = he(e.toFixed(20))) != null ? a : Lr);
}
function Ye(e, t = e.s, a = !1) {
  const r = ft(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function Zn(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Xt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function Ir(e, t) {
  const a = Xt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function Or(e, t, a = "exclude-first") {
  const r = Xt(e) > Xt(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Xt(s) - Xt(o) + (l ? 1 : 0), i = l ? Ir(s, 1) : s;
  let m = i.y - o.y, u = i.m - o.m, d = i.d - o.d;
  if (d < 0) {
    u -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, _ = i.m === 1 ? i.y - 1 : i.y;
    d += Le(_, p);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d, swapped: r };
}
function $n(e, t) {
  return Ir(e, t);
}
function Ga(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const Og = ["월", "화", "수", "목", "금", "토", "일"];
function ea(e) {
  return Og[Xt(e) % 7];
}
function Fe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const tn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Hn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Va(e) {
  var t;
  return (t = Hn[e]) != null ? t : e in Hn ? Hn[e] : null;
}
function ta(e, t) {
  return e.find((a) => a.code === t);
}
function Pr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Xr(e, t, a, r) {
  const o = ta(e, a), s = ta(e, r);
  if (!o || !s) return null;
  const l = he(o.krw), c = he(s.krw), i = he(String(o.per)), m = he(String(s.per));
  if (!l || !c || !i || !m) return null;
  const u = Tt(tt(t, l), i);
  if (!u) return null;
  const d = Tt(tt(u, m), c);
  return d ? {
    value: ft(d, 2, "half"),
    notice: `${Pr(o)} · 참고용 환율`
  } : null;
}
function Pg(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? Rr(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = un(a, o.value);
          break;
        case "-":
          a = ua(a, o.value);
          break;
        case "*":
          a = tt(a, o.value);
          break;
        default: {
          const s = Tt(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : Lr;
  return { ok: !0, value: t ? ft(r, t.digits, t.mode) : r };
}
const Ja = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function rn() {
  return { sign: "+", text: "" };
}
function Xg(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function zg(e) {
  return e.map((t) => ({ sign: t.sign, value: he(t.text) }));
}
function Fg(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, m = q([]), u = Math.min(r, t.length - 1);
  G(() => {
    var w;
    (w = m.current[u]) == null || w.focus();
  }, [u, t.length]);
  const d = Pg(zg(t), { digits: s, mode: c }), p = d.ok ? Ye(d.value, s, !0) : "0으로 나눌 수 없음", _ = (w, x) => {
    a(t.map((E, g) => g === w ? { ...E, ...x } : E));
  }, y = (w = t.length, x = "") => {
    const E = [...t];
    E.splice(w, 0, { ...rn(), text: x }), a(E), o(w);
  }, f = (w) => {
    if (t.length === 1) {
      a([rn()]);
      return;
    }
    a(t.filter((x, E) => E !== w)), o(Math.max(0, w - 1));
  }, b = () => {
    d.ok && y(t.length, Ye(d.value, s, !0));
  }, $ = (w, x) => {
    const E = w.key, g = Wg(E);
    if (g && !(E === "-" && t[x].text === "")) {
      w.preventDefault(), _(x, { sign: g });
      return;
    }
    if (E === "v" || E === "V") {
      w.preventDefault(), b();
      return;
    }
    E === "Enter" ? (w.preventDefault(), x === t.length - 1 ? y() : o(x + 1)) : E === "ArrowDown" ? (w.preventDefault(), o(Math.min(x + 1, t.length - 1))) : E === "ArrowUp" ? (w.preventDefault(), o(Math.max(x - 1, 0))) : E === "Insert" ? (w.preventDefault(), y(x + 1)) : E === "Delete" && t[x].text === "" ? (w.preventDefault(), f(x)) : E === "F4" && (w.preventDefault(), k());
  }, k = () => {
    a([rn()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => f(u) }, "라인삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: k }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, Ja.map((w) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: w.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === w.key,
        onClick: () => _(u, { sign: w.key })
      },
      w.label,
      " (",
      w.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (w) => l(Number(w.target.value)) }, [0, 1, 2, 3, 4].map((w) => /* @__PURE__ */ n.createElement("option", { key: w, value: w }, w))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (w) => i(w.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((w, x) => {
    var E;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (E = Ja.find((g) => g.key === w.sign)) == null ? void 0 : E.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (g) => {
          m.current[x] = g;
        },
        value: w.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => o(x),
        onChange: (g) => _(x, { text: Xg(g.target.value) }),
        onKeyDown: (g) => $(g, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p))));
}
function Wg(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function Hg(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = he(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class Kg {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? un(t.value, r.value) : ua(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: tt(t.value, r.value) };
      else {
        const o = Tt(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Rr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Ug(e) {
  const t = Hg(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new Kg(t).parse();
}
const on = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], Yg = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Gg(e, t) {
  return e.replace(/오늘/g, Fe(t)).replace(/내일/g, Fe($n(t, 1))).replace(/어제/g, Fe($n(t, -1)));
}
function Vg(e) {
  const t = [];
  for (const a of e.matchAll(Yg)) {
    const r = Zn(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const Jg = /부터|까지|에서|일수|며칠|기간|차이|~/;
function Qg(e, t) {
  if (t.length < 2 || !Jg.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Or(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Fe(t[0])} ~ ${Fe(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const Zg = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function eE(e, t) {
  if (t.length !== 1) return null;
  const a = Zg.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = $n(l, s) : a[2] === "주" ? c = $n(l, s * 7) : a[2] === "년" ? c = Ga(l, s * 12) : c = Ga(l, s), {
    ok: !0,
    explain: `${Fe(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${Fe(c)} (${ea(c)})`
  };
}
function tE(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? zr(a[2]) : null, o = he(a[1]);
  if (!o) return null;
  const s = r ? tt(o, r) : o, l = Va(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : Va(nE(e));
  if (!i || i === l) return null;
  const m = Xr(t, s, l, i);
  return m ? {
    ok: !0,
    explain: `${Ye(s, s.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ye(m.value, 2, !0)} ${i}`
  } : null;
}
function nE(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const aE = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function zr(e) {
  var t;
  return (t = he(aE[e])) != null ? t : ma(1);
}
const rE = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, oE = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function sE(e) {
  return e.replace(rE, (t) => {
    let a = he("0"), r = !1;
    for (const o of t.matchAll(oE)) {
      const s = he(o[1]);
      s && (r = !0, a = un(a, o[2] ? tt(s, zr(o[2])) : s));
    }
    return r ? Ye(a, a.s) : t;
  });
}
const lE = /원화|원|엔|씩|개월|개|명|건/g;
function cE(e) {
  return sE(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(lE, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const iE = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function uE(e, t, a) {
  const r = he("1"), o = Ye(tt(t, ma(100)), 0);
  if (a === "add")
    return {
      value: ft(tt(e, un(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = Tt(tt(e, t), un(r, t));
  return {
    value: s ? ft(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function mE(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: on };
  const r = Gg(a, t.today), o = Vg(r), s = Qg(r, o);
  if (s) return s;
  const l = eE(r, o);
  if (l) return l;
  const c = tE(r, (i = t.rates) != null ? i : []);
  return c || dE(r, t);
}
function dE(e, t) {
  var m, u;
  const a = iE.exec(e), r = a ? e.slice(0, a.index) : e, o = cE(r);
  if (!o) return { ok: !1, supported: on };
  const s = Ug(o);
  if (!s.ok)
    return { ok: !1, supported: on };
  if (!a)
    return { ok: !0, explain: o, value: Qa(s.value), expr: o };
  const l = (u = (m = fE(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...on]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = uE(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: Qa(i.value),
    expr: o
  };
}
function fE(e) {
  var a;
  if (!e) return null;
  const t = he(e);
  return t && (a = Tt(t, ma(100))) != null ? a : null;
}
function Qa(e) {
  const t = ft(e, 2, "half"), a = ft(t, 0, "down");
  return ua(t, a).u === BigInt(0) ? Ye(t, 0, !0) : Ye(t, 2, !0);
}
const Ue = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Za(e, t) {
  const a = Ue[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = he(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function _E(e, t, a, r, o = 4, s = "half") {
  const l = Za(e, t), c = Za(e, a);
  if (!l || !c) return null;
  const i = Tt(tt(r, l), c);
  return i ? ft(i, o, s) : null;
}
const pE = [0, 1, 2, 3, 4, 6], yE = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function bE(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = S(() => r == null ? [rn()] : [{ sign: "+", text: Ye(NE(r), 0, !0) }]), [m, u] = S(0), [d, p] = S(0), [_, y] = S("half"), f = q(null);
  G(() => {
    const $ = (k) => {
      k.key === "Escape" && (k.preventDefault(), o());
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [o]), G(() => {
    var $, k;
    (k = ($ = f.current) == null ? void 0 : $.querySelector("[data-autofocus]")) == null || k.focus();
  }, [t]);
  const b = ($) => {
    const k = [...c.filter((w) => w.text !== ""), { sign: "+", text: $ }, rn()];
    i(k), u(k.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: f }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, yE.map(($) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: $.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": $.key === t,
      onClick: () => a($.key)
    },
    $.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(EE, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    Fg,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: d,
      onDigits: p,
      mode: _,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(vE, null), t === "unit" && /* @__PURE__ */ n.createElement(kE, null), t === "fx" && /* @__PURE__ */ n.createElement(wE, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const hE = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], gE = 20;
function EE({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = S(""), [s, l] = S(null), [c, i] = S(!1), [m, u] = S(!1), d = q(!1), p = we(da, []), _ = (f) => {
    o(f), u(!1);
    const b = mE(f, { today: p, rates: tn, taxRate: null });
    l(b), f.trim() && t([f, ...e.filter(($) => $ !== f)].slice(0, gE));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (f) => o(f.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (f) => {
        f.key === "Enter" && !f.shiftKey && !d.current && !f.nativeEvent.isComposing && (f.preventDefault(), _(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, hE.map((f) => /* @__PURE__ */ n.createElement("button", { key: f, type: "button", className: "bical-chip", onClick: () => _(f) }, f))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var f;
        (f = navigator.clipboard) == null || f.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : on).map((f) => /* @__PURE__ */ n.createElement("li", { key: f }, f))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((f) => !f) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((f) => /* @__PURE__ */ n.createElement("li", { key: f }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => _(f) }, f))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function vE() {
  const e = we(da, []), [t, a] = S(Fe(e)), [r, o] = S(Fe(e)), [s, l] = S("exclude-first"), c = Zn(t), i = Zn(r), m = c && i ? Or(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => o(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, Fe(c), "(", ea(c), ") ~ ", Fe(i), "(", ea(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function kE() {
  const [e, t] = S("area"), [a, r] = S(Ue.area.units[0].key), [o, s] = S(Ue.area.units[4].key), [l, c] = S(""), [i, m] = S(4), [u, d] = S("half"), p = (f) => {
    t(f), r(Ue[f].units[0].key), s(Ue[f].units[1].key), c("");
  }, _ = he(l), y = _ ? _E(e, a, o, _, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (f) => p(f.target.value) }, Object.keys(Ue).map((f) => /* @__PURE__ */ n.createElement("option", { key: f, value: f }, Ue[f].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", Ue[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (f) => c(f.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (f) => r(f.target.value) }, Ue[e].units.map((f) => /* @__PURE__ */ n.createElement("option", { key: f.key, value: f.key }, f.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: o, onChange: (f) => s(f.target.value) }, Ue[e].units.map((f) => /* @__PURE__ */ n.createElement("option", { key: f.key, value: f.key }, f.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (f) => m(Number(f.target.value)) }, pE.map((f) => /* @__PURE__ */ n.createElement("option", { key: f, value: f }, f))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (f) => d(f.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, er(e, a), " → ", er(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ye(y, i, !0) : "—")));
}
function er(e, t) {
  var a, r;
  return (r = (a = Ue[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function wE() {
  const e = we(da, []), [t, a] = S(Fe(e)), [r, o] = S("JPY"), [s, l] = S("KRW"), [c, i] = S(""), m = he(c), u = m ? Xr(tn, m, r, s) : null, d = ta(tn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (p) => o(p.target.value) }, tn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (p) => l(p.target.value) }, tn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, d ? Pr(d) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ye(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function da() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function NE(e) {
  var t;
  return ft((t = he(String(e))) != null ? t : he("0"), 0, "half");
}
const Fr = Dn(null);
function iv({ children: e }) {
  const [t, a] = S(!1), [r, o] = S("text"), [s, l] = S(null), [c, i] = S([]), [m, u] = S(0), d = we(() => ({
    open: (p) => {
      var _, y;
      o((_ = p == null ? void 0 : p.tab) != null ? _ : "text"), l((y = p == null ? void 0 : p.seed) != null ? y : null), u((f) => f + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(Fr.Provider, { value: d }, e, t && /* @__PURE__ */ n.createElement(
    bE,
    {
      key: m,
      tab: r,
      onTab: o,
      seed: s,
      onClose: d.close,
      history: c,
      onHistory: i
    }
  ));
}
function uv() {
  var e;
  return (e = xn(Fr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class mv extends tr {
  constructor() {
    super(...arguments), this.rootRef = Kr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new sr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  Cp as $,
  ov as A,
  zE as B,
  bE as C,
  UE as D,
  PE as E,
  hn as F,
  Un as G,
  U0 as H,
  S0 as I,
  M0 as J,
  aa as K,
  Q0 as L,
  R0 as M,
  O0 as N,
  P0 as O,
  u0 as P,
  ia as Q,
  m0 as R,
  tf as S,
  _0 as T,
  I0 as U,
  DE as V,
  J0 as W,
  OE as X,
  H0 as Y,
  j0 as Z,
  q0 as _,
  qo as a,
  Js as a$,
  L0 as a0,
  Zf as a1,
  T0 as a2,
  tv as a3,
  v0 as a4,
  IE as a5,
  ME as a6,
  RE as a7,
  Uf as a8,
  qg as a9,
  X0 as aA,
  kr as aB,
  nf as aC,
  $g as aD,
  br as aE,
  Ut as aF,
  mv as aG,
  sr as aH,
  Dr as aI,
  Rd as aJ,
  zn as aK,
  cr as aL,
  Mu as aM,
  t_ as aN,
  Gn as aO,
  Pc as aP,
  Xc as aQ,
  ur as aR,
  D0 as aS,
  w_ as aT,
  Ys as aU,
  h0 as aV,
  xg as aW,
  Qs as aX,
  P_ as aY,
  Lo as aZ,
  CE as a_,
  TE as aa,
  jE as ab,
  BE as ac,
  t0 as ad,
  ZE as ae,
  QE as af,
  ev as ag,
  LE as ah,
  C0 as ai,
  p0 as aj,
  Z0 as ak,
  e0 as al,
  qE as am,
  or as an,
  av as ao,
  rv as ap,
  Kf as aq,
  AE as ar,
  lv as as,
  k0 as at,
  Bt as au,
  VE as av,
  f0 as aw,
  FE as ax,
  _r as ay,
  z0 as az,
  d0 as b,
  lr as b0,
  V0 as b1,
  r1 as b2,
  o1 as b3,
  Nn as b4,
  It as b5,
  Vf as b6,
  Qt as b7,
  Cr as b8,
  Jf as b9,
  yr as bA,
  N0 as bB,
  uv as bC,
  b0 as bD,
  af as bE,
  w0 as bF,
  y0 as bG,
  B0 as bH,
  JE as bI,
  cv as bJ,
  SE as bK,
  sv as bL,
  GE as bM,
  Yt as bN,
  ny as bO,
  s0 as ba,
  lc as bb,
  YE as bc,
  n_ as bd,
  Sr as be,
  C_ as bf,
  Vs as bg,
  ir as bh,
  Gs as bi,
  Ro as bj,
  x_ as bk,
  G0 as bl,
  Uy as bm,
  zt as bn,
  Mr as bo,
  hr as bp,
  c0 as bq,
  ku as br,
  qd as bs,
  o0 as bt,
  HE as bu,
  WE as bv,
  Vl as bw,
  KE as bx,
  tc as by,
  xr as bz,
  F0 as c,
  Ft as d,
  iv as e,
  i0 as f,
  fr as g,
  nv as h,
  Y0 as i,
  Ua as j,
  r0 as k,
  a0 as l,
  n0 as m,
  A0 as n,
  $a as o,
  l0 as p,
  W0 as q,
  Ar as r,
  Us as s,
  x0 as t,
  $0 as u,
  g0 as v,
  E0 as w,
  K0 as x,
  XE as y,
  Uo as z
};
